<template>
  <main>
    <template v-if="!isLoading">
      <section class="page-header">
        <div class="d-flex align-items-center">
          <span class="clickable mr-2" @click="$router.go(-1)" v-if="showGoBackButton">
            <i class="mdi mdi-chevron-left" style="font-size: 2rem"></i>
          </span>
          <div class="process-header">
            <h2 class="process-title mb-0">{{ pageTitle }}</h2>
            <h6 class="mt-0">{{ pageSubTitle }}</h6>
          </div>
        </div>
        <div class="d-flex">
          <lm-button-v2
            v-if="showGoBackButtonText"
            @click="$router.go(-1)"
          >
          Volver
          </lm-button-v2>
          <div
            v-for="(item, index) of stepsButtons"
            :key="index"
            :class="{'ml-3': item.condition}"
          >
            <lm-button-v2
              v-if="item.condition && (item.position === 'top' || item.position === 'both')"
              v-bind="item"
              :shape="item.icon ? 'circle': null"
              :loading="isProcessing"
              @click="item.click"
              :variant="item.variant"
            >
              {{ !item.icon ? item.label : null }}
            </lm-button-v2>
          </div>
          <template v-if="statusList.length">
            <a-dropdown :trigger="['click']" :disabled="!actionsAvailables.processCanBeChangedStatusByMe || !processWasStarted">
              <a-menu slot="overlay">
                <a-menu-item
                  v-for="item of statusList"
                  :key="item.id"
                  @click="statusChange = true; statusToBeChanged = item"
                >
                  <span :class="`status-squad-icon color-${item.id}`"></span>
                  {{ item.name }}
                </a-menu-item>
              </a-menu>
              <a-button
                class="ml-3"
                :loading="isProcessing"
                :class="`status-button color-${statusToBeChanged ? statusToBeChanged.id : processForm.lumbreStatus.id}`"
              >
                <template v-if="statusChange">
                  {{ statusToBeChanged.name }} <a-icon v-if="actionsAvailables.processCanBeChangedStatusByMe && processWasStarted" type="down" />
                </template>
                <template v-else>
                  {{ processForm.lumbreStatusName }} <a-icon v-if="actionsAvailables.processCanBeChangedStatusByMe && processWasStarted" type="down" />
                </template>
              </a-button>
            </a-dropdown>
          </template>
          <template v-else>
              <a-button
                v-if="processForm.lumbreStatus"
                :disabled="true"
                class="ml-3"
                :loading="isProcessing"
                :class="`status-button color-${statusToBeChanged ? statusToBeChanged.id : processForm.lumbreStatus.id}`"
              >
                <template >
                  {{ processForm.lumbreStatusName }}
                </template>
              </a-button>
          </template>
          <b-modal
            id="request-start-modal"
            :title="$t('select_a_request_starter')"
            centered
          >
            <LmRadio
              v-model="requesterCategory"
              name="requesterCategory"
              :label="$t('requester')"
              :options="requestersCategoriesOptions"
            />
            <!-- <LmTreeSelect
              v-if="requesterCategory === 'subarea'"
              placeholder="Área"
              clearable
              :options="requestStartOptions.areas"
              v-model="areaValue"
            /> -->
            <LmTreeSelect
              :key="requesterCategory"
              :placeholder="requestersCategoriesOptions.find(el => el.value === requesterCategory)?.text"
              clearable
              :options="requestersOptions"
              v-model="requester"
            />
            <template #modal-footer>
              <b-button variant="secondary" @click="$bvModal.hide('request-start-modal')">Cancelar</b-button>
              <b-button variant="primary" @click="onStart">Confirmar</b-button>
            </template>
          </b-modal>
        </div>
      </section>

      <section class="page-content">
        <div class="bg-light rounded-lg p-0 w-100">
          <a-steps
            v-if="!processWasStarted"
            v-model="currentStep"
            type="navigation"
            size="small"
          >
            <a-step
              :title="$t('choose_a_requester_step')"
              :status="stepStatus(0)"
            />
            <a-step
              :title="$t('process_configuration_step')"
              :status="stepStatus(1)"
            />
            <a-step
              :title="$t('add_documents_step')"
              :status="stepStatus(2)"
            />
            <a-step
              :title="$t('confirmation_step')"
              :status="stepStatus(3)"
            />
          </a-steps>

          <section class="p-3 rounded-lg bg-white position-relative">
            <!-- Step 0 -->
            <template v-if="currentStep === 0">
              <div class="initiators-list mb-5">
                <article
                  v-for="item of initiators"
                  :key="item._id"
                  class="rounded-lg bg-light p-2 border clickable"
                  :class="{ 'selected border-primary': currentInitiatorType && item._id === currentInitiatorType._id }"
                  @click="onSelectInitiator(item)"
                >
                  <span class="d-block border-bottom py-3 bg-primary text-center text-white rounded">{{ item.typeName }}</span>
                </article>
              </div>
              <div v-if="currentInitiatorType">
                <template v-if="currentInitiatorType.starterType === 'people'">
                  <b-card no-body class="border">
                    <b-tabs card>
                      <b-tab title="Principal">
                        <div class="row">
                          <div class="col-md-4 col-sm-12">
                            <LmTreeSelect
                              label="Tipo de identificador"
                              class="mt-4"
                              :options="currentInitiatorType.idType"
                              v-model="identifier.type"
                            />
                            <LmTextInput
                              label="Número"
                              v-model="identifier.id"
                              @input="onInitiatorChange"
                            />
                            <lm-button-v2 type="primary" @click="onSearchInitiator" >
                              {{ $t('search') }}
                            </lm-button-v2>
                          </div>
                          <div class="col-md-8 col-sm-12">
                            <a-descriptions title="Iniciador Principal" layout="vertical">
                              <template v-if="currentInitiator">
                                <a-descriptions-item label="Nombre o Razón Social">
                                  {{ currentInitiator.personName }}
                                </a-descriptions-item>
                                <a-descriptions-item label="Email" span="1">
                                  {{ currentInitiator.personEmail }}
                                </a-descriptions-item>
                              </template>
                            </a-descriptions>
                            <lm-button-v2 v-if="currentInitiator" type="primary" @click="onShowInitiatorDetails" >
                              {{ $t('view_more') }}
                            </lm-button-v2>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab title="Adicionales" :disabled="!currentInitiator">
                        <div>
                          <b-card class="border"
                            v-for="(item, index) of processForm.processAdditionalInitiators"
                            :key="index"
                            >
                            <div class="row">
                              <div class="col-md-4 col-sm-12">
                                <LmTreeSelect
                                  class="mt-4"
                                  label="Tipo de identificador"
                                  :options="currentInitiatorType.idType"
                                  v-model="item.identifier.type"
                                />
                                <LmTextInput
                                  label="Número"
                                  v-model="item.identifier.id"
                                  @input="onAdditionalInitiatorChange(index)"
                                />
                                <lm-button-v2 type="primary" @click="onSearchAdditionalInitiator(index)" >
                                  {{ $t('search') }}
                                </lm-button-v2>
                                <lm-button-v2 type="primary" class="ml-2" @click="onDeleteAdditionalInitiator(index)" >
                                  {{ $t('takeoff') }}
                                </lm-button-v2>
                              </div>
                              <div class="col-md-8 col-sm-12">
                                <a-descriptions :title="`Iniciador Adicional (${index+1}):`" layout="vertical">
                                  <template v-if="!item.isLoading">
                                    <a-descriptions-item label="Nombre o Razón Social">
                                      {{ item.additionalInitiator.personName }}
                                    </a-descriptions-item>
                                    <a-descriptions-item label="Email" span="1">
                                      {{ item.additionalInitiator.personEmail }}
                                    </a-descriptions-item>
                                  </template>
                                </a-descriptions>
                                <lm-button-v2 v-if="!item.isLoading" type="primary" @click="onShowAdditionalInitiatorDetails(index)" >
                                  {{ $t('view_more') }}
                                </lm-button-v2>
                              </div>
                            </div>
                          </b-card>
                          <lm-button-v2 class="mt-2" type="primary" @click="onAddAdditionalInitiator" >
                            {{ $t('add') }}
                          </lm-button-v2>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </template>
                <template v-else>
                  <LmFormBuilder
                    class="initiator-formbuilder mt-2"
                    disablePageTitleData
                    ref="lmFormbuilder-initiator"
                    :isParentOnEditMode="isOnEditMode"
                    :endpointUriwhereGetComponents="formbuilderInitiatorUri"
                    :formValues="currentInitiator ? currentInitiator.fields : {}"
                    @formObjectToSendToServerChange="onChangeInitiatorData"
                  />
                </template>
              </div>
            </template>

            <!-- Step 1 -->
            <template v-if="currentStep === 1">
              <template v-if="step0completed">
                <portal to="processName">
                  <LmTextInput
                    class="col-12 px-0"
                    v-model="processForm.processName"
                    :v="validation('processForm.processName')"
                    :label="$t('name')"
                    :placeholder="$t('name')"
                  />
                </portal>
                <portal to="processAddress">
                  <div v-if="currentInitiatorType.starterType === 'people'">
                    <template v-if="googleMapsApiKey">
                      <b-row class="mb-2">
                        <LmGooglePlacesAutocomplete
                          class="col-6"
                          label="Direccion"
                          @placeChanged="placeChanged"
                          @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
                          :value="processForm.processAddress"
                          :v="validation('processForm.processAddress')"
                        />
                        <LmLeaFletMap
                          :markerLatLng="markerLatLng"
                          :centerMapCoordinate="markerLatLng"
                          class="col-6"
                          height="250px"
                          />
                      </b-row>
                    </template>
                    <template v-else>
                      <LmTextInput
                        class="col-12 px-0"
                        v-model="processForm.processAddress"
                        :v="validation('processForm.processAddress')"
                        :label="$t('address')"
                        :placeholder="$t('address')"
                      />
                    </template>
                  </div>
                </portal>
                <LmFormBuilder
                  ref="process-formbuilder"
                  disablePageTitleData
                  :isParentOnEditMode="isOnEditMode"
                  :endpointUriwhereGetComponents="formbuilderProcessUri"
                  :contentTemplateData="processForm"
                  :formValues="processForm"
                  @formObjectToSendToServerChange="updateProcessForm"
                />
              </template>
              <template v-else>
                <h4>Configuración del trámite</h4>
                <p>Debes completar los datos del iniciador antes de seguir en esta sección.</p>
              </template>
            </template>

            <!-- Step 2 -->
            <template v-if="currentStep === 2">
              <b-card no-body class="border">
                <b-tabs card>
                  <b-tab title="Documentos BUDD" active v-if="showBuddDocumentsTab">
                    <b-row>
                      <b-col v-if="processForm.documents.length">
                        <a-table
                          bordered
                          :columns="tableColumns"
                          :data-source="tableData"
                          :loading="isTableLoading"
                          :customRow="customRow"
                          :customHeaderRow="customHeaderRow"
                          :pagination="{ hideOnSinglePage: true }"
                        >
                          <span slot="name" slot-scope="text, record">
                            {{ text }}
                            <a-tooltip v-if="record.metadata.replacement_date"
                              :title="replacementFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" />
                            </a-tooltip>
                            <a-tooltip v-if="record.hasBeenDeleted"
                              :title="removedFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" />
                            </a-tooltip>
                          </span>
                          <span slot="action" slot-scope="text, record">
                            <div class="d-flex" style="column-gap: .5rem">
                              <a-tooltip v-if="!record.hasBeenDeleted" title="Ver documento">
                                <lm-button-v2 shape="circle" icon="eye" :loading="isDocumentsLoading" @click="onOpenDocumentViewerModal(record, 'budds')" />
                              </a-tooltip>
                              <a-tooltip v-if="!record.hasBeenDeleted" title="Ver detalles">
                                <lm-button-v2 shape="circle" icon="edit" @click="onOpenDocument(record)" />
                              </a-tooltip>
                              <a-tooltip title="Subsanar">
                                <lm-button-v2 shape="circle" icon="retweet" @click="onShowReplacementModal(record)" v-if="record.canBeCorrected" />
                              </a-tooltip>
                              <a-tooltip title="Eliminar">
                                <lm-button-v2 shape="circle" icon="delete" @click="onRemoveDocument(record)" v-if="record.canBeDeleted" />
                              </a-tooltip>
                            </div>
                          </span>
                        </a-table>
                        <template v-if="processForm.documents.length">
                          <a-modal v-model="showReplacementModal" title="Solicitud de Confirmación">
                            <template slot="footer">
                              <div class="d-flex justify-content-end" style="gap: .5rem">
                                <lm-button-v2 @click="showReplacementModal = false; documentToBeReplaced = null">
                                  Cancelar
                                </lm-button-v2>
                                <lm-button-v2 type="danger" @click="onReplaceDocumentWithDelete">
                                  Eliminar
                                </lm-button-v2>
                                <lm-button-v2 type="primary" @click="onReplaceDocument">
                                  Reemplazar
                                </lm-button-v2>
                              </div>
                            </template>
                            <p>¿Desea eliminar el documento {{ documentToBeReplacedName }} o reemplazarlo por uno nuevo?</p>
                          </a-modal>
                          <a-modal
                            v-model="showReplacementDocumentModal"
                            centered
                            width="85%"
                            title="Documento reemplazante"
                            :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }"
                            :okText="$t('confirm')"
                            :cancelText="$t('cancel')"
                            @ok="onConfirmReplacementDocument"
                          >
                            <LmDataTable
                              ref="datatable-app-replacement-documents"
                              slug="documentos-para-subsanacion"
                              :queryString="documentToBeReplaced ? `NOT (id: ${documentToBeReplaced._id})` : null"
                              hideButtons
                            />
                          </a-modal>
                        </template>
                        <!-- <b-list-group v-if="processForm.documents.length">
                          <b-list-group-item
                            v-for="(item, index) in processForm.documents"
                            :key="item.id"
                            class="d-flex justify-content-between align-items-center"
                          >
                            <b-button
                              class="my-0"
                              variant="link"
                              size="sm"
                              @click="onOpenDocumentInPdf(item.id || item._id)"
                            >
                              {{ item.name || item.documentNumber || item.documentName }}
                            </b-button>
                            <font-awesome-icon class="trash-icon clickable" icon="trash" @click="processForm.documents.splice(index, 1)" />
                          </b-list-group-item>
                        </b-list-group> -->
                        <LmSvgIcon
                          v-else
                          icon="LmNoDataIcon"
                          width="7.5em"
                          wrapperClass="mb-4 d-flex flex-column align-items-center"
                          text="No hay documentos asignados a este trámite."
                        />
                      </b-col>
                    </b-row>
                    <div class="mt-3 d-flex" style="gap: .75rem">
                      <lm-button-v2 v-if="showAddDocumentsButton" type="primary" variant="info" v-b-modal.documents-datatable-modal>Buscar existente</lm-button-v2>
                      <lm-button-v2 v-if="showAddDocumentsButton" type="primary" v-b-modal.document-types-datatable-modal>Crear nuevo</lm-button-v2>
                    </div>
                  </b-tab>
                  <b-tab title="Documentos Internos" v-if="showInternalDocumentsTab">
                    <LmUploadFiles
                      label="Subir documentos"
                      duplicateCheck
                      v-model="processForm.internalDocuments"
                      :dropzoneOptions="{
                        acceptedFiles: acceptedFormats,
                        headers: {
                          'Cache-Control': null,
                          'X-Requested-With': null
                        },
                        withCredentials: true,
                        thumbnailWidth: 150,
                        maxFilesize: 5,
                        timeout: 120000,
                        addRemoveLinks: true,
                        maxFiles: null,
                        clickable: true
                      }"
                    />
                  </b-tab>
                </b-tabs>
              </b-card>
            </template>

            <!-- Step 3 -->
            <template v-if="currentStep === 3">
              <template v-if="step0completed && step1completed">
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-column">
                    <div class="d-flex mb-2" style="gap: 5rem">
                      <div class="d-flex flex-column">
                        <small class="text-uppercase" style="font-size: 11px">Número</small>
                        <span class="h6 mt-0">{{ processForm.processNumber || 'Numeración pendiente' }}</span>
                      </div>
                      <div class="d-flex flex-column">
                        <small class="text-uppercase" style="font-size: 11px">Iniciador</small>
                        <span class="h6 mt-0">{{ getCurrentInitiatorName }}</span>
                      </div>
                      <div class="d-flex flex-column" v-if="processWasStarted && processForm.processRelationships.length">
                        <small class="text-uppercase" style="font-size: 11px">Asociaciones</small>
                        <span class="h6 mt-0">Hay {{ processForm.processRelationships.length }} trámites asociados</span>
                      </div>
                    </div>
                    <div class="d-flex" style="gap: .5rem">
                      <lm-button-v2 type="primary" v-if="isOnEditMode" @click="onShowCoverPage">{{ $t('show_cover') }}</lm-button-v2>
                      <lm-button-v2 type="primary" @click="onShowInitiatorDetails">{{ $t('initiator_data') }}</lm-button-v2>
                      <lm-button-v2 v-if="currentInitiatorType.starterType === 'people'" type="primary" @click="onShowAdditionalInitiatorsModal">{{ $t('additional_initiator_data') }}</lm-button-v2>
                      <lm-button-v2 v-if="processForm.processRelationships.length" type="primary" v-b-modal.linked-processes-modal>{{ $t('associated') }}</lm-button-v2>
                      <lm-button-v2 v-if="actionsAvailables.processCanBeEditedByMePermissions && actionsAvailables.processCanBeEdited" @click="showFormbuilderForEdit = true" type="primary">{{ $t('update_process') }}</lm-button-v2>
                      <lm-button-v2 v-if="actionsAvailables.processCanBeEditedCoverPage && actionsAvailables.processCanBeEditedByMePermissions" type="primary" @click="onUpdateCover">{{ $t('update_cover') }}</lm-button-v2>
                    </div>
                  </div>
                  <div>
                    <div class="d-flex flex-column align-items-end">
                      <div class="d-flex justify-content-center" style="gap: 1rem" v-if="lastMovement">
                        <div class="d-flex flex-column align-items-end">
                          <span class="text-uppercase">{{ $t('current_location') }}</span>
                          <span class="h6 mt-0" v-if="lastMovement.key !== 'user'">{{ lastMovement.name }}</span>
                          <small class="my-0 font-weight-bold" v-if="lastMovement.area">{{ lastMovement.area }}</small>
                        </div>
                        <a-tooltip v-if="lastMovement.key === 'user'" placement="topRight">
                          <template slot="title">
                            {{ lastMovement.name }}
                          </template>
                          <b-avatar
                            class="mb-2"
                            size="35px"
                            variant="primary"
                            :text="lastMovement.initials"
                            :src="lastMovement.avatar"
                          >
                          </b-avatar>
                        </a-tooltip>
                      </div>
                      <lm-button-v2
                        v-if="showNewPassButton"
                        class="mt-2"
                        type="primary"
                        @click="onOpenToolbarProcessPasses"
                      >
                        {{$t('do_movement')}}
                      </lm-button-v2>
                    </div>
                  </div>
                </div>
                <!-- Si puede editar el trámite y se encuentra en edicion se permite modificar los datos
                     del trámite.
                -->
                <a-modal
                  v-if="this.actionsAvailables.processCanBeEditedByMePermissions && isOnEditMode"
                  v-model="showFormbuilderForEdit"
                  width="85%"
                >
                  <portal to="processName">
                    <LmTextInput
                      class="col-12 px-0"
                      v-model="processForm.processName"
                      :v="validation('processForm.processName')"
                      :label="$t('name')"
                      :placeholder="$t('name')"
                    />
                  </portal>
                  <portal to="processAddress">
                    <div v-if="currentInitiatorType.starterType === 'people'">
                      <template v-if="googleMapsApiKey">
                        <b-row class="mb-2">
                          <LmGooglePlacesAutocomplete
                            class="col-6"
                            label="Direccion"
                            @placeChanged="placeChanged"
                            @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
                            :value="processForm.processAddress"
                            :v="validation('processForm.processAddress')"
                          />
                          <LmLeaFletMap
                            :markerLatLng="markerLatLng"
                            :centerMapCoordinate="markerLatLng"
                            class="col-6"
                            height="250px"
                            />
                        </b-row>
                      </template>
                      <template v-else>
                        <LmTextInput
                          class="col-12 px-0"
                          v-model="processForm.processAddress"
                          :v="validation('processForm.processAddress')"
                          :label="$t('address')"
                          :placeholder="$t('address')"
                        />
                      </template>
                    </div>
                  </portal>
                  <LmFormBuilder
                    class="px-0"
                    ref="process-formbuilder"
                    disablePageTitleData
                    :isParentOnEditMode="isOnEditMode"
                    :endpointUriwhereGetComponents="formbuilderProcessUri"
                    :contentTemplateData="processForm"
                    :formValues="processForm"
                    @formObjectToSendToServerChange="updateProcessForm"
                  />
                  <template #footer>
                    <a-button @click="processForm = processFormCopy; showFormbuilderForEdit = false; getProcess()">{{ $t('cancel') }}</a-button>
                    <a-button v-if="actionsAvailables.processCanBeEditedCoverPage" type="primary" @click="onSaveWithFeedback">{{ $t('continue') }}</a-button>
                    <a-button v-else type="primary" @click="onSaveWithoutFeedback">{{ $t('continue') }}</a-button>
                  </template>
                </a-modal>
                <b-card class="border mt-5" no-body v-if="showBuddDocumentsTab || showInternalDocumentsTab">
                  <b-tabs card>
                    <b-tab active title="Documentos BUDD" v-if="showBuddDocumentsTab">
                      <template v-if="processForm.documents.length">
                        <!-- <LmDataTable
                          slug="documentos-seleccionados-para-budd"
                          :queryString="automationQs"
                          hideButtons
                        /> -->
                        <a-table
                          bordered
                          :columns="tableColumns"
                          :data-source="tableData"
                          :loading="isTableLoading"
                          :customRow="customRow"
                          :customHeaderRow="customHeaderRow"
                          :pagination="{ hideOnSinglePage: true }"
                        >
                          <span slot="name" slot-scope="text, record">
                            {{ text }}
                            <a-tooltip :title="replacementFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" v-if="record.hasBeenCorrected" />
                            </a-tooltip>
                            <a-tooltip v-if="record.hasBeenDeleted"
                              :title="removedFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" />
                            </a-tooltip>
                          </span>

                          <span slot="action" slot-scope="text, record">
                            <div class="d-flex" style="column-gap: .5rem">
                              <a-tooltip v-if="!record.hasBeenDeleted" title="Ver documento">
                                <lm-button-v2 shape="circle" icon="eye" :loading="isDocumentsLoading" @click="onOpenDocumentViewerModal(record, 'budds')" />
                              </a-tooltip>
                              <a-tooltip v-if="!record.hasBeenDeleted" title="Ver detalles">
                                <lm-button-v2 shape="circle" icon="edit" @click="onOpenDocument(record)" />
                              </a-tooltip>
                              <a-tooltip title="Subsanar">
                                <lm-button-v2 shape="circle" icon="retweet" @click="onShowReplacementModal(record)" v-if="record.canBeCorrected" />
                              </a-tooltip>
                              <a-tooltip title="Eliminar">
                                <lm-button-v2 shape="circle" icon="delete" @click="onRemoveDocument(record)" v-if="record.canBeDeleted" />
                              </a-tooltip>
                            </div>
                          </span>
                        </a-table>
                        <a-modal v-model="showReplacementModal" title="Solicitud de Confirmación" @cancel="documentToBeReplaced = null">
                          <template slot="footer">
                            <div class="d-flex justify-content-end" style="gap: .5rem">
                              <lm-button-v2 @click="showReplacementModal = false; documentToBeReplaced = null">
                                Cancelar
                              </lm-button-v2>
                              <lm-button-v2 :loading="isProcessing" type="danger" @click="onReplaceDocumentWithDelete">
                                Eliminar
                              </lm-button-v2>
                              <lm-button-v2 :loading="isProcessing" type="primary" @click="onReplaceDocument">
                                Reemplazar
                              </lm-button-v2>
                            </div>
                          </template>
                          <p>¿Desea eliminar el documento {{ documentToBeReplacedName }} o reemplazarlo por uno nuevo?</p>
                        </a-modal>
                        <a-modal
                          v-model="showReplacementDocumentModal"
                          centered
                          width="85%"
                          title="Documento reemplazante"
                          :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }"
                          :okText="$t('confirm')"
                          :cancelText="$t('cancel')"
                          @ok="onConfirmReplacementDocument"
                        >
                          <LmDataTable
                            ref="datatable-app-replacement-documents"
                            slug="documentos-para-subsanacion"
                            :queryString="documentToBeReplaced ? `NOT (id: ${documentToBeReplaced._id})` : null"
                            hideButtons
                          />
                        </a-modal>
                      </template>
                      <template v-else>
                        <h4 class="text-center h3 mb-4">
                          No hay documentos de la BUDD asociados
                        </h4>
                      </template>
                      <div class="mt-3 d-flex" style="gap: .75rem">
                        <lm-button-v2 v-if="showAddDocumentsButton" variant="info" type="primary" v-b-modal.documents-datatable-modal>Buscar existente</lm-button-v2>
                        <lm-button-v2 v-if="showAddDocumentsButton" type="primary" v-b-modal.document-types-datatable-modal>Crear nuevo</lm-button-v2>
                      </div>
                    </b-tab>
                    <b-tab title="Documentos Internos" v-if="showInternalDocumentsTab">
                      <template v-if="processForm.internalDocuments.length">
                        <a-table
                          bordered
                          :columns="internalDocumentsFields"
                          :data-source="internalDocumentsItems"
                          :loading="isTableLoading"
                          :customHeaderRow="customHeaderRow"
                          :customRow="customRow"
                          :pagination="{ hideOnSinglePage: true }"
                        >
                          <span slot="name" slot-scope="text, record">
                            {{ text }}
                            <a-tooltip :title="replacementFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" v-if="record.metadata.replacement_date" />
                            </a-tooltip>
                            <a-tooltip v-if="record.hasBeenDeleted"
                              :title="removedFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" />
                            </a-tooltip>
                          </span>

                          <span slot="action" slot-scope="text, record">
                            <div class="d-flex" style="column-gap: .5rem">
                              <a-tooltip v-if="fileIsValidForViewer(record.src)" title="Ver documento">
                                <lm-button-v2 shape="circle" icon="eye" :loading="isDocumentsLoading" @click="onOpenDocumentViewerModal(record, 'internals')" />
                              </a-tooltip>
                              <a-tooltip v-else title="Ver documento">
                                <a :href="record.src" target="_blank" rel="noopener noreferrer">
                                  <lm-button-v2 shape="circle" icon="download">
                                  </lm-button-v2>
                                </a>
                              </a-tooltip>
                              <a-tooltip title="Eliminar">
                                <lm-button-v2 shape="circle" icon="delete" @click="onRemoveInternalDocument(record)" v-if="record.removable" />
                              </a-tooltip>
                            </div>
                          </span>
                        </a-table>
                      </template>
                      <template v-else>
                        <h4 class="text-center h3 mb-4">
                          No hay documentos internos asociados
                        </h4>
                      </template>
                      <b-row class="mt-3">
                        <lm-button-v2 v-if="showAddInternalDocumentsButton" class="col-auto" type="primary" variant="info" v-b-modal.add-external-documents-modal>Agregar documento</lm-button-v2>
                      </b-row>
                    </b-tab>
                    <b-tab title="Planos" v-if="showBlueprintsTab">
                      <template v-if="processForm.blueprints.length">
                        <a-table
                          bordered
                          :columns="blueprintColumns"
                          :data-source="blueprintsTableData"
                          :loading="isTableLoading"
                          :customRow="customRow"
                          :customHeaderRow="customHeaderRow"
                          :pagination="{ hideOnSinglePage: true }"
                        >
                          <span slot="name" slot-scope="text, record">
                            {{ text }}
                            <a-tooltip v-if="record.hasBeenDeleted"
                              :title="blueprintRemovedFeedbackDateTooltip(record)">
                              <a-icon type="info-circle" class="ml-2" />
                            </a-tooltip>
                          </span>
                          <span slot="action" slot-scope="text, record">
                            <div class="d-flex" style="column-gap: .5rem">
                              <a-tooltip v-if="!record.hasBeenDeleted" title="Ver documento">
                                <lm-button-v2 shape="circle" icon="eye" :loading="isDocumentsLoading" @click="onOpenDocumentViewerModal(record, 'blueprints')" />
                              </a-tooltip>
                              <a-tooltip v-if="!record.hasBeenDeleted" title="Ver detalles">
                                <lm-button-v2 shape="circle" icon="edit" @click="onOpenBlueprint(record)" />
                              </a-tooltip>
                              <a-tooltip title="Eliminar">
                                <lm-button-v2 shape="circle" icon="delete" @click="onRemoveBlueprint(record)" v-if="record.canBeDeleted" />
                              </a-tooltip>
                            </div>
                          </span>
                        </a-table>
                      </template>
                      <template v-else>
                        <h4 class="text-center h3 mb-4">
                          Aún no hay planos asociados
                        </h4>
                      </template>
                      <div class="mt-3 d-flex" style="gap: .75rem">
                        <lm-button-v2 v-if="showAddBlueprintsButton" variant="info" type="primary" v-b-modal.blueprints-datatable-modal>Buscar existente</lm-button-v2>
                        <!-- <lm-button-v2 v-if="showAddBlueprintsButton" type="primary" v-b-modal.document-types-datatable-modal>Crear nuevo</lm-button-v2> -->
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-card>
                <h4 v-else class="text-center h3 mb-4">
                  <hr class="w-100 my-5">
                  Aún no hay documentos asociados
                </h4>
                <!-- Modals -->
                <b-modal id="cover-page-preview-modal" size="xl" hide-footer>
                  <template v-if="coverPagePreview" #title>{{ coverPagePreview.name }}</template>
                  <template v-if="coverPagePreview">
                    <iframe v-if="coverPagePreview.src" :src="coverPagePreview.src" width="100%" :height="700"/>
                  </template>
                </b-modal>
                <b-modal
                  id="initiator-modal"
                  :title="currentInitiator?.name"
                  centered
                  size="xl"
                  hide-footer
                >
                  <h3 class="mb-0">Iniciador: {{ currentInitiatorType.typeName }}</h3>
                  <div class="my-4">
                    <LmFormBuilder
                      class="px-0"
                      disablePageTitleData
                      isDisabled
                      ref="formbuilder-initiator"
                      :isParentOnEditMode="isOnEditMode"
                      :endpointUriwhereGetComponents="formbuilderInitiatorUri"
                      :formValues="currentInitiator ? currentInitiator.fields : {}"
                    />
                  </div>
                </b-modal>
                <b-modal
                  id="linked-processes-modal"
                  title="Trámites asociados"
                  hide-footer
                  centered
                >
                  <template v-if="processForm.processRelationships.length">
                    <b-list-group>
                      <b-list-group-item
                        v-for="(item, index) in processForm.processRelationships"
                        :key="index"
                      >
                        <span class="d-flex justify-content-between align-items-center">
                          <span class="d-flex align-items-center">
                            <b-link
                              :to="processPath(item)"
                              class="mr-2"
                            >
                              {{ item.name }}
                            </b-link>
                            <b-badge>{{ item.code }}</b-badge>
                          </span>
                          <i class="mdi mdi-delete clickable" style="font-size: 1.3rem" v-b-popover.hover.top="'Eliminar'" @click="onRemoveProcessLink(item)"></i>
                        </span>
                      </b-list-group-item>
                    </b-list-group>
                  </template>
                  <p v-else>{{ $t('no_associated_processes') }}</p>
                </b-modal>
                <b-modal
                  id="add-external-documents-modal"
                  title="Agregar documentos internos"
                  size="xl"
                  ok-only
                  ok-title="Cerrar"
                  centered
                >
                  <LmUploadFiles
                    label="Subir documentos"
                    duplicateCheck
                    @input="onAddInternalDocument"
                    :dropzoneOptions="{
                      acceptedFiles: acceptedFormats,
                      headers: {
                        'Cache-Control': null,
                        'X-Requested-With': null
                      },
                      withCredentials: true,
                      thumbnailWidth: 150,
                      maxFilesize: 5,
                      timeout: 120000,
                      addRemoveLinks: true,
                      maxFiles: null,
                      clickable: true
                    }"
                  />
                </b-modal>
              </template>
              <template v-else>
                <p>Debes completar los datos del iniciador y del trámite antes de seguir en esta sección.</p>
              </template>
            </template>
          </section>

          <div class="d-flex m-4" style="gap: .5rem">
            <lm-button-v2
              v-if="showPrevButton"
              :loading="isProcessing"
              @click="onPrevStep"
            >
              {{$t('previous')}}
            </lm-button-v2>
            <lm-button-v2
              v-if="showNextButton"
              :loading="isProcessing"
              @click="onNextStep"
            >
              {{$t('next')}}
            </lm-button-v2>
            <!-- <lm-button-v2
              v-if="showSaveButton"
              type="primary"
              variant="info"
              :loading="isProcessing"
              @click="onSave"
            >
              {{$t('save')}}
            </lm-button-v2>
            <lm-button-v2
              v-if="showSaveAsDraftButton"
              type="primary"
              variant="info"
              :loading="isProcessing"
              @click="onSave"
            >
              {{$t('save_as_draft')}}
            </lm-button-v2> -->
          </div>
          <div class="d-flex ml-2 mb-4" >
            <div
            v-for="(item, index) of stepsButtons"
            :key="index"
            :class="{'ml-3': item.condition}"
          >
            <lm-button-v2
              v-if="item.condition && (item.position === 'bottom' || item.position === 'both')"
              v-bind="item"
              :shape="item.icon ? 'circle': null"
              :loading="isProcessing"
              @click="item.click"
              :variant="item.variant"
            >
              {{ !item.icon ? item.label : null }}
            </lm-button-v2>
          </div>
          </div>
        </div>
        <LmToolbar
          ref="toolbar"
          class="bg-light"
          style="padding-top: 0"
          contentClass="border-0 shadow-none"
          :isOnEditMode="isOnEditMode"
          :items="toolbarItems"
          :config="toolbarConfig"
          @onProcessStatusChange="onProcessStatusChange"
          @onProcessPassChange="onProcessPassChange"
          @onContentTemplateChange="onContentTemplateChange"
          @onAddLinkedProcesses="onAddLinkedProcesses"
          @change="onToolbarModeChange"
          @onUnsavedChanges="onUnsavedChanges"
        />
      </section>
    </template>
    <LmLoading v-else />

    <!-- Modal de visualizacion de documentos -->
    <a-modal
      v-model="showDocumentsViewer"
      width="85%"
      dialogClass="my-4"
      :bodyStyle="{'padding-top': '3.3rem'}"
      :footer="false"
      destroy-on-close
      centered
    >
      <LmFileViewer ref="fileviewer" :initial-position="fileViewerIniialPosition" :files="currentFileList" v-if="currentFileList.length" @handleForward="onBackwardForward" @handleBackward="onBackwardForward" :lazyLoad="true"/>
    </a-modal>

    <!-- Modal de confirmación general -->
    <LmConfirmationModal
      ref="confirmation-modal"
    />
    <!-- Modal de preview de documento -->
    <b-modal
      v-if="currentStep === 2 || currentStep === 3"
      id="document-preview-modal"
      :title="documentInPdf ? documentInPdf.name : 'Documento'"
      size="xl"
      scrollable
      hide-footer
    >
      <div class="vh-100">
        <LmComponentLoading v-if="!documentInPdf" />
        <iframe
          v-else
          :src="documentInPdf.src"
          frameborder="0"
          width="100%"
          height="100%"
          class="preview-iframe"
        ></iframe>
      </div>
    </b-modal>
    <!-- Modal para agregar documentos al tramite -->
    <b-modal
      id="document-types-datatable-modal"
      size="xl"
      scrollable
      hide-header
      hide-footer
    >
      <LmDataTable
        slug="tipos-de-documento-todos"
        hideButtons
      />
    </b-modal>
    <!-- Modal documentos del budd -->
    <b-modal
      id="documents-datatable-modal"
      size="xl"
      scrollable
      hide-header
      @ok="onConfirmAppDocuments"
      @hidden="automation.qs = null"
      :cancel-title="$t('cancel')"
      :ok-title="$t('confirm')"
    >
      <LmDataTable
        ref="datatable-app-documents"
        :slug="datatableForBudd"
        :queryString="automationQs"
        hideButtons
      />
    </b-modal>
    <!-- Modal documentos de blueprints -->
    <b-modal
      id="blueprints-datatable-modal"
      size="xl"
      scrollable
      hide-header
      @ok="onConfirmAppBlueprints"
      @hidden="automation.qs = null"
      :cancel-title="$t('cancel')"
      :ok-title="$t('confirm')"
    >
      <LmDataTable
        ref="datatable-app-blueprints"
        :slug="datatableForBlueprints"
        :queryString="queryStringForBlueprints"
        hideButtons
      />
    </b-modal>
    <!-- Modal persona -->
    <b-modal
      id="people-initiator-modal"
      :title="currentInitiator ? 'Información de Iniciador' : 'Crear Iniciador'"
      hide-footer
      scrollable
      size="xl"
      centered
    >
      <template v-if="currentInitiatorType">
        <LmPeopleNewOrEdit
          :isOnModalEditMode="Boolean(initiatorPeopleData._id)"
          hideToolbar
          :hideSaveButton="Boolean(initiatorPeopleData._id)"
          :peopleTypeId="currentInitiatorType._id"
          :personData="initiatorPeopleData"
          @onNewPerson="onCreatePeopleInitiator"
          @onUpdatePerson="onUpdatePeopleInitiator"
          @cancel="$bvModal.hide('people-initiator-modal')"
        />
      </template>
    </b-modal>

    <!-- Modal con todos los iniciadores adicionales -->
    <b-modal
      id="people-all-additional-initiator-modal"
      title="Información de los Iniciadores Adicionales"
      hide-footer
      scrollable
      size="xl"
      centered
    >
      <LmAdditionalInitiatorsNewOrEdit
        :currentInitiatorType="currentInitiatorType"
        :processForm="processForm"
        :actionsAvailables="actionsAvailables"
        @onAdditionalInitiatorChange="onAdditionalInitiatorChange"
        @onSearchAdditionalInitiator="onSearchAdditionalInitiator"
        @onDeleteAdditionalInitiator="onDeleteAdditionalInitiator"
        @onShowAdditionalInitiatorDetails="onShowAdditionalInitiatorDetails"
        @onAddAdditionalInitiator="onAddAdditionalInitiator"
        @cancel="$bvModal.hide('people-all-additional-initiator-modal')"
      />
    </b-modal>

    <!-- Modal iniciador adicional -->
    <b-modal
      id="people-additional-initiator-modal"
      :title="currentInitiator ? 'Información de Iniciador' : 'Crear Iniciador'"
      hide-footer
      scrollable
      size="xl"
      centered
    >
      <template v-if="currentInitiatorType">
        <LmPeopleNewOrEdit
          :isOnModalEditMode="Boolean(additionalInitiatorPeopleData._id)"
          hideToolbar
          :hideSaveButton="Boolean(additionalInitiatorPeopleData._id)"
          :peopleTypeId="currentInitiatorType._id"
          :personData="additionalInitiatorPeopleData"
          @onNewPerson="onCreateAdditionalPeopleInitiator"
          @onUpdatePerson="onUpdateAdditionalPeopleInitiator"
          @cancel="$bvModal.hide('people-additional-initiator-modal')"
        />
      </template>
    </b-modal>

    <template v-if="toolbarMode === 'documentModel'">
      <portal to="processName">
        <LmTextInput
          :value="processForm.processName"
          :v="validation('processForm.processName')"
          class="col-12 px-0"
          :label="$t('name')"
          :placeholder="$t('name')"
          disabled
        />
      </portal>
      <portal to="processAddress">
        <div v-if="currentInitiatorType.starterType === 'people'">
          <b-row class="mb-2">
            <LmTextInput
              :value="processForm.processAddress"
              :v="validation('processForm.processAddress')"
              class="col-6"
              :label="$t('address')"
              :placeholder="$t('address')"
              disabled
            />
            <LmLeaFletMap
              :markerLatLng="markerLatLng"
              :centerMapCoordinate="markerLatLng"
              class="col-6"
              height="250px"
              />
          </b-row>
        </div>
      </portal>
    </template>
  </main>
</template>

<script>
import { defineComponent } from 'vue'

// Components
import LmDataTable from '@/components/lmDataTable/table'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmRadio from '@/components/form/elements/LmRadio'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmToolbar from '@/components/lmToolBar'
import LmFileViewer from '@/components/LmFileViewer'
import LmPeopleNewOrEdit from '@/views/LmPeopleNewOrEdit'
import LmAdditionalInitiatorsNewOrEdit from '@/views/LmAdditionalInitiatorsNewOrEdit'
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'

// Utils
import lmToasts from '@/mixins/lmToasts.js'
import commonsApi from '@/api/commons'
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'
import moment from 'moment'
import 'moment/locale/es'

// Vuex
import { mapMutations, mapGetters } from 'vuex'

moment.locale('es')

export default defineComponent({
  mixins: [lmToasts],

  provide () {
    const context = {}
    for (const key in this.context) {
      Object.defineProperty(context, key, {
        enumerable: true,
        get: () => this.context[key]
      })
    }
    return { context }
  },

  components: {
    LmTreeSelect,
    LmButton,
    LmButtonV2,
    LmTextInput,
    LmRadio,
    LmUploadFiles,
    LmFormBuilder,
    LmDataTable,
    LmConfirmationModal,
    LmToolbar,
    LmFileViewer,
    LmPeopleNewOrEdit,
    LmGooglePlacesAutocomplete,
    LmLeaFletMap,
    LmAdditionalInitiatorsNewOrEdit
  },

  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },

  validations () {
    const validations = {
      processForm: {}
    }
    validations.processForm.processName = { required }
    if (this.currentInitiatorType?.starterType === 'people') {
      validations.processForm.processAddress = { required }
    }
    return validations
  },

  data () {
    return {
      isLoading: false,
      isProcessing: false,
      isTableLoading: false,
      isDocumentsLoading: false,
      showReplacementModal: false,
      showReplacementDocumentModal: false,
      showFormbuilderForEdit: false,
      showDocumentsViewer: false,
      // Necesito saber si lmfileviewer está mostrando budds o internals
      fileViewerMode: 'budds',
      fileViewerIniialPosition: 0,
      requestStartOptions: {
        areas: null,
        subareas: null,
        users: null
      },
      actionsAvailables: {
        processCanBeStartedByMe: false,
        processCanBeRequestStartedByMe: false,
        processCanBeCreatedByMe: false,
        processCanBeTakenByMe: false,
        processCanAllowMeToAddMovements: false,
        processCanAllowMeToAddDocuments: false,
        processCanAllowMeToAddInternalDocuments: false,
        processCanBeRejectedByMe: false,
        processCanBeChangedStatusByMe: false,
        processCanBeReOpenByMe: false
      },
      statusList: [],
      currentStep: 0,
      stepsMovements: [],
      toolbarMode: null,
      processChange: false,
      documentsChange: false,
      statusChange: false,
      statusToBeChanged: null,
      documentToBeReplaced: null,
      internalDocumentsToAppend: [],
      fileList: [],
      currentFileList: [],
      automation: {
        required: null,
        errorMsg: null,
        qs: null
      },

      // Step 0
      step0completed: false,
      initiators: [],
      currentInitiatorType: null,
      currentInitiator: null,
      identifier: {
        type: null,
        id: null
      },

      // Step 1
      step1completed: false,
      processTypeForm: {},
      processFormCopy: {},
      markerLatLng: [],
      processForm: {
        processName: '',
        processAddress: '',
        processAddressLatLong: [],
        documents: [],
        blueprints: [],
        internalDocuments: [],
        processRelationships: [],
        processAdditionalInitiators: []
      },

      // Step 2
      step2completed: true,
      documentInPdf: null,

      // Step 3
      step3completed: true,
      coverPagePreview: null,
      requester: null,
      requesterCategory: 'user',
      areaValue: null,
      requestersCategoriesOptions: [
        { text: 'Usuario', value: 'user' },
        { text: 'Área', value: 'area' },
        { text: 'Subárea', value: 'subarea' }
      ],
      additionalInitiatorToShowOnModal: null
    }
  },

  computed: {
    ...mapGetters('processes', ['lastDocumentCreated', 'dataToPersist']),
    ...mapGetters('settings', ['googleMapsApiKey']),
    context () {
      return {
        toolbarCtx: 'processes',
        areaValue: this.areaValue
      }
    },
    disableAutomations () {
      return process.env?.VUE_APP_ENABLE_AUTOMATIONS !== 'yes'
    },
    processTypeId () {
      return this.$route.params?.processTypeId || null
    },
    processTypeMasterId () {
      return this.processTypeForm?._master || this.processTypeId
    },
    processId () {
      return this.$route.params?.id || null
    },
    pageTitle () {
      return !this.isOnEditMode ? 'Crear Nuevo Trámite' : this.processForm.processName || 'Nombre del trámite'
    },
    pageSubTitle () {
      return this.processTypeForm.typeAlias
    },
    formbuilderInitiatorUri () {
      return '/formbuilder/' + this.currentInitiatorType?.formbuilderId || ''
    },
    formbuilderPeopleUri () {
      return '/formbuilder/' + this.currentInitiatorType?.peopleFieldsFormbuilderId || ''
    },
    formbuilderProcessUri () {
      return '/formbuilder/' + this.processTypeForm?.formbuilderId || ''
    },
    acceptedFormats () {
      return [
        { id: 1, name: 'PDF' },
        { id: 2, name: 'DOC' },
        { id: 3, name: 'DOCX' },
        { id: 4, name: 'XLS' },
        { id: 5, name: 'XLSX' },
        { id: 6, name: 'TXT' },
        { id: 7, name: 'JPG' },
        { id: 8, name: 'PNG' }
      ]
    },
    automationQs () {
      let qs = '*'

      if (this.processForm.documents.length) {
        const documentsIds = this.processForm.documents.map(el => el.id)
        qs = 'NOT (id: (' + documentsIds.join(' OR ') + '))'

        if (this.automation.qs) {
          qs += 'AND ' + this.automation.qs
        }
      } else {
        if (this.automation.qs) {
          qs = this.automation.qs
        }
      }
      return qs
    },
    queryStringForBlueprints () {
      let qs = '*'
      const activeBlueprints = this.processForm.blueprints.filter(i => !i.hasBeenDeleted)
      if (activeBlueprints.length) {
        const blueprintsIds = activeBlueprints.map(el => el.id)
        qs = 'NOT (id: (' + blueprintsIds.join(' OR ') + '))'
      }
      return qs
    },
    processWasStarted () {
      return this.isOnEditMode && this.processForm?.processDate !== undefined
    },
    showPrevButton () {
      return this.currentStep !== 0 && !this.processWasStarted
    },
    showNextButton () {
      return this.currentStep !== 3 && !this.processWasStarted
    },
    showTakeButton () {
      if (this.actionsAvailables.processCanBeTakenByMe) {
        return true
      }
      return false
    },
    showReOpenButton () {
      if (this.actionsAvailables.processCanBeReOpenByMe) {
        return true
      }
      return false
    },
    showNewPassButton () {
      if ((this.processWasStarted && this.actionsAvailables.processCanAllowMeToAddMovements) || (this.processWasStarted && this.actionsAvailables.processCanBeEditedByMePermissions && this.actionsAvailables.processCanAllowMeToAddMovements)) {
        return true
      }
      return false
    },
    showRejectButton () {
      if (this.actionsAvailables.processCanBeRejectedByMe) {
        return true
      }
      return false
    },
    showStartButton () {
      if (this.actionsAvailables.processCanBeStartedByMe) {
        return this.processCanBeStartedOrRequestedToStart
      }
      return false
    },
    showRequestStartButton () {
      if (this.actionsAvailables.processCanBeRequestStartedByMe && !this.actionsAvailables.processCanBeStartedByMe) {
        return this.processCanBeStartedOrRequestedToStart
      }
      return false
    },
    showSaveAsDraftButton () {
      if (
        !this.processWasStarted &&
        (this.actionsAvailables.processCanBeCreatedByMe || this.actionsAvailables.processCanBeEditedByMe) &&
        (this.documentsChange || this.processForm.documents.some(el => el.order === 'N/A') || this.processChange)
      ) {
        return this.processCanBeStartedOrRequestedToStart
      }
      return false
    },
    showSaveButton () {
      if (
        this.processWasStarted &&
        (this.actionsAvailables.processCanBeEditedByMe || this.actionsAvailables.processCanBeEditedByMePermissions) &&
        (this.documentsChange || this.processForm.documents.some(el => el.order === 'N/A') || this.processChange)
      ) {
        return true
      }
      return false
    },
    showSaveNewStatus () {
      return Boolean(this.statusChange) && !this.showSaveButton
    },
    showAddDocumentsButton () {
      return this.actionsAvailables.processCanAllowMeToAddDocuments
    },
    showAddBlueprintsButton () {
      return this.actionsAvailables.processCanAllowMeToAddDocuments
    },
    showAddInternalDocumentsButton () {
      return this.actionsAvailables.processCanAllowMeToAddInternalDocuments
    },
    showBuddDocumentsTab () {
      return true
    },
    showInternalDocumentsTab () {
      return true
    },
    showBlueprintsTab () {
      return true
    },
    showGoBackButton () {
      return this.$route.params.showGoBackButton || true
    },
    showDeleteButton () {
      if (this.actionsAvailables.processCanBeDeletedByMe) {
        return true
      }
      return false
    },
    // Requerimientos mínimos para iniciar, solicitar iniciar o guardar un proceso
    processCanBeStartedOrRequestedToStart () {
      return (
        this.step0completed &&
        this.step1completed &&
        this.step2completed
      )
    },
    requestParams () {
      const payload = {
        ...this.processForm,
        internalDocuments: this.internalDocumentsToAppend,
        processTypeId: this.processTypeId,
        processTypeMasterId: this.processTypeMasterId,
        processStarter: {
          id: this.currentInitiator._id || this.currentInitiator.id,
          name: this.currentInitiator.personName || this.currentInitiator.name,
          starterTypeId: this.currentInitiatorType._id,
          starterType: this.currentInitiatorType.starterType
        },
        // Normalizo los iniciadores adicionales
        processAdditionalInitiators: this.processForm.processAdditionalInitiators.filter((obj) => obj.hasOwnProperty('additionalInitiator') && obj.additionalInitiator?.personName).map(i => {
          return {
            id: i.additionalInitiator._id,
            name: i.additionalInitiator.personName,
            starterTypeId: this.currentInitiatorType._id,
            starterType: this.currentInitiatorType.starterType
          }
        })
      }
      if (this.isOnEditMode) {
        payload.id = this.processId
      }
      if (!this.actionsAvailables.processCanBeStartedByMe && this.actionsAvailables.processCanBeRequestStartedByMe) {
        payload.destination = {
          [this.requesterCategory]: this.requester
        }
      }
      payload.documents = payload.documents.filter(el => el.order === 'N/A')
      delete payload.processRelationships
      return payload
    },
    lastMovement () {
      const destination = this.processForm?.lastMovement?.destination
      if (destination) {
        const type = Object.keys(destination).find(el => destination[el] !== null)
        const names = {
          area: this.processForm.lastMovement?.destination?.user?.area?.name || '',
          subarea: this.processForm.lastMovement?.destination?.user?.subarea?.name || '',
          group: this.processForm.lastMovement?.destination?.user?.group?.name || '',
          user: 'usuario'
        }
        let nameToDisplay = destination[type]?.name
        if (type === 'user' && !destination[type]?.name) {
          nameToDisplay = `${destination[type]?.firstname} ${destination[type]?.lastname}`
        }
        return {
          key: type,
          typeName: names[type],
          name: nameToDisplay,
          area: names?.area,
          subarea: names?.subarea,
          avatar: this.processForm.lastMovement?.destination?.user?.avatar || null,
          initials: this.processForm.lastMovement?.destination?.user?.initials || null
        }
      }
      return null
    },
    initiatorPeopleData () {
      return {
        _id: this.processForm.processStarter?.id || this.currentInitiator?._id || null,
        personName: this.currentInitiator?.personName || '',
        personEmail: this.currentInitiator?.personEmail || '',
        personIdType: this.identifier.type,
        personId: this.identifier.id
      }
    },
    additionalInitiatorPeopleData () {
      return {
        _id: this.processForm.processAdditionalInitiators[this.additionalInitiatorToShowOnModal]?.additionalInitiator._id || null,
        personName: this.processForm.processAdditionalInitiators[this.additionalInitiatorToShowOnModal]?.additionalInitiator.personName || '',
        personEmail: this.processForm.processAdditionalInitiators[this.additionalInitiatorToShowOnModal]?.additionalInitiator.personEmail || '',
        personIdType: this.processForm.processAdditionalInitiators[this.additionalInitiatorToShowOnModal]?.identifier.type || null,
        personId: this.processForm.processAdditionalInitiators[this.additionalInitiatorToShowOnModal]?.identifier.id || null
      }
    },
    toolbarItems () {
      let items = []
      if (this.isOnEditMode) {
        items = [
          'tags',
          'contentTemplates',
          'processHistory',
          'auditMovements',
          'processMovements',
          'documentModel',
          'processGenerateZip'
        ]
        if (this.actionsAvailables.processCanBeEditedByMe) {
          items.push(null)
          if (this.processForm?.lumbreStatus?.id === '3') {
            items.push('processLink')
          }
        }
        if ((this.processWasStarted && this.actionsAvailables.processCanAllowMeToAddMovements) || (this.processWasStarted && this.actionsAvailables.processCanBeEditedByMePermissions && this.actionsAvailables.processCanAllowMeToAddMovements)) {
          items.push('processPasses')
        }
        if (!this.hideComments) {
          items.unshift('comments')
        }
      } else {
        items = [
          'contentTemplates'
        ]
      }
      return items
    },
    toolbarConfig () {
      return {
        comments: {
          linkType: 'processes',
          disabled: this.disableComments
        },
        contentTemplates: {
          path: `/contenttemplate/${this.processTypeId}/processtypes/all`,
          template: {
            ...this.processForm,
            currentInitiator: this.currentInitiator,
            currentInitiatorType: this.currentInitiatorType
          },
          reference: this.processTypeId
        },
        documentModel: {
          formbuilderPath: '/formbuilder/' + this.processTypeForm.formbuilderId,
          dataPathOnEditMode: '/processes/' + this.processId,
          customization: {
            title: 'Ver trámite completo',
            popoverTitle: 'Ver trámite completo'
          }
        },
        processHistory: {
          historyEndpoint: '/processes/history'
        },
        processMovements: {
          historyEndpoint: '/processes/movements'
        },
        auditMovements: {
          serviceName: 'processes'
        },
        processPasses: {
          processName: this.processForm.processName || '',
          changesUnsaved: this.showSaveAsDraftButton || this.showSaveButton || this.showSaveNewStatus
        },
        processLink: {
          linkedProcesses: this.processForm.processRelationships
        },
        processGenerateZip: {
          reference: this.processId
        },
        tags: {
          serviceName: 'processes'
        }
      }
    },
    requestersCategoriesOptions2 () {
      return [
        { text: 'Usuario', value: 'user' },
        { text: 'Área', value: 'area' },
        { text: 'Subárea', value: 'subarea' }
      ]
    },
    requestersOptions () {
      if (this.requesterCategory === 'area') {
        return this.requestStartOptions.areas
      } else if (this.requesterCategory === 'subarea') {
        return this.requestStartOptions.subareas
      } else if (this.requesterCategory === 'user') {
        return this.requestStartOptions.users
      }
    },
    subareaChildrenOf () {
      return this.requesterCategory === 'subarea' ? 'areaValue' : null
    },
    internalDocumentsFields () {
      return [
        { dataIndex: 'name', title: 'Nombre' },
        { dataIndex: 'created_at', title: 'Fecha' },
        { dataIndex: 'action', title: 'Acciones', scopedSlots: { customRender: 'action' } }
      ]
    },
    internalDocumentsItems () {
      return this.processForm.internalDocuments.map((el, index) => {
        return {
          key: index,
          name: el.originalname || el.name,
          created_at: moment(el.created_at || new Date()).format('DD [de] MMM, YYYY - hh:mm'),
          id: el.id || el.uid || el.uuid,
          removable: el.removable !== undefined ? el.removable : true,
          src: el.src || process.env.VUE_APP_API_URL_STATIC_ASSETS + el.path
        }
      })
    },
    stepsButtons () {
      return [
        {
          label: this.$t('cancel'),
          type: 'secondary',
          position: 'bottom',
          condition: true,
          click: () => this.onCancel()
        },
        {
          label: this.$t('save'),
          // icon: 'save',
          type: 'primary',
          variant: 'primary',
          position: 'both', // posible values top, bottom or both
          condition: this.showSaveButton,
          click: () => this.onSave()
        },
        {
          label: this.$t('save'),
          type: 'primary',
          variant: 'primary',
          position: 'both',
          condition: this.showSaveNewStatus,
          click: () => this.onChangeStatus()
        },
        {
          label: this.$t('save_as_draft'),
          type: 'primary',
          variant: 'info',
          position: 'both',
          condition: this.showSaveAsDraftButton,
          click: () => this.onSave()
        },
        {
          label: this.$t('start'),
          type: 'success',
          variant: null,
          position: 'both',
          condition: this.showStartButton,
          click: () => this.onStart()
        },
        {
          label: this.$t('request_start'),
          type: 'success',
          variant: null,
          position: 'both',
          condition: this.showRequestStartButton,
          click: () => this.onRequestStart()
        },
        {
          label: this.$t('take'),
          type: 'success',
          position: 'both',
          condition: this.showTakeButton,
          click: () => this.onTakeConfirmation()
        },
        {
          label: this.$t('reopen'),
          type: 'success',
          position: 'top',
          condition: this.showReOpenButton,
          click: () => this.onReOpen()
        },
        {
          label: this.$t('reject'),
          type: 'danger',
          confirmation: true,
          confirmationTitle: this.$t('reject_procedure'),
          confirmationMessage: this.$t('are_you_sure_you_want_to_reject_this_procedure'),
          commentIsRequired: this.processForm.createdFromTad,
          commentValidationIsRequired: true,
          commentTitle: 'Motivo (será enviado por mail al iniciador)',
          position: 'top',
          condition: this.showRejectButton,
          click: (comment) => this.onReject(comment)
        },
        {
          label: this.$t('delete'),
          type: 'danger',
          confirmation: true,
          confirmationTitle: this.$t('delete_procedure'),
          confirmationMessage: this.$t('are_you_sure_you_want_to_delete_this_procedure'),
          position: 'both',
          condition: this.showDeleteButton,
          click: () => this.onDelete()
        }
      ]
    },

    tableColumns () {
      return [
        {
          title: 'Orden',
          dataIndex: 'order'
        },
        {
          title: 'Número',
          dataIndex: 'documentNumber'
        },
        {
          title: 'Tipo de Documento',
          dataIndex: 'documentTypeAlias'
        },
        {
          title: 'Nombre',
          dataIndex: 'documentName',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: 'Fecha',
          dataIndex: 'created_at'
        },
        {
          title: 'Acciones',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    tableData () {
      return this.processForm.documents.map((el, index) => {
        return {
          key: index,
          order: el.order,
          canBeCorrected: el.canBeCorrected || false,
          hasBeenCorrected: el.hasBeenCorrected || false,
          hasBeenDeleted: el.hasBeenDeleted || false,
          canBeDeleted: el.canBeDeleted || false,
          metadata: el.metadata,
          created_at: moment(el.created_at).format('DD [de] MMM, YYYY - HH:mm'),
          ...el.document,
          documentNumber: el.document?.documentNumber || 'N/A'
        }
      })
    },

    blueprintColumns () {
      return [
        // {
        //   title: 'Orden',
        //   dataIndex: 'order'
        // },
        {
          title: 'Nombre',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: 'Tipo',
          dataIndex: 'typeAlias'
        },
        {
          title: 'Nomenclatura',
          dataIndex: 'nomenclaturaCode'
        },
        {
          title: 'Cuenta',
          dataIndex: 'nomenclaturaCuenta'
        },
        {
          title: 'Fecha',
          dataIndex: 'created_at'
        },
        {
          title: 'Eliminado',
          dataIndex: 'deleted_at'
        },
        {
          title: 'Acciones',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    blueprintsTableData () {
      return this.processForm.blueprints.map((el, index) => {
        return {
          key: index,
          // order: el.order,
          ...el.blueprint,
          canBeCorrected: el.canBeCorrected || false,
          hasBeenCorrected: el.hasBeenCorrected || false,
          hasBeenDeleted: el.hasBeenDeleted || false,
          canBeDeleted: el.canBeDeleted || false,
          metadata: el.metadata,
          created_at: moment(el.created_at).format('DD [de] MMM, YYYY - HH:mm'),
          deleted_at: el.deleted_at
        }
      })
    },

    documentToBeReplacedName () {
      return this.documentToBeReplaced?.documentName || ''
    },

    showGoBackButtonText () {
      return 'viewer' in this.$route.query
    },

    datatableForBudd () {
      return this.processTypeForm?.customDatatableForBUDD ? this.processTypeForm.customDatatableForBUDD : 'documentos-seleccionables-para-budd'
    },

    datatableForBlueprints () {
      return this.processTypeForm?.customDatatableForBlueprints ? this.processTypeForm.customDatatableForBlueprints : 'planos-seleccionables-para-tramites'
    },

    getCurrentInitiatorName () {
      return this.currentInitiator?.personName || this.currentInitiator?.name || ''
    }
  },

  methods: {
    ...mapMutations('processes', ['setDataToPersist', 'setProcessPath', 'clearProcessesStore']),
    onCancel () {
      this.$router.go(-1)
    },
    customRow (record, index) {
      const props = {}
      if (record.hasBeenDeleted) {
        props.class = 'a-table-row-disabled'
      } else if (record.hasBeenCorrected) {
        props.class = 'a-table-row'
      }
      props.class += ' a-table-row'
      return props
    },

    customHeaderRow (column, index) {
      return {
        class: 'a-table-header-row'
      }
    },

    onToolbarModeChange (event) {
      this.toolbarMode = event
    },

    validation (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },

    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastWarningMessage(
          'No podrás iniciar el trámite hasta que completes los campos del formulario correctamente',
          'Formulario con errores'
        )
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },

    stepStatus (step) {
      if (this.stepsMovements.includes(step) && !this[`step${step}completed`]) {
        return 'error'
      } else if (this.stepsMovements.includes(step) && this[`step${step}completed`]) {
        return 'finish'
      }
      return 'wait'
    },

    // Cambio la información de un iniciador tipo iniciador
    onChangeInitiatorData (event) {
      const keyToPick = this.currentInitiatorType.initiatorIdField.id
      const value = event[keyToPick]
      this.currentInitiator = {
        ...value,
        fields: event,
        starterTypeId: this.currentInitiatorType._id
      }
      this.processForm.initiatorFields = event
    },

    async onUpdateCover () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPostWrapper(`/processes/regeneratecoverpage/${this.processId}`)
        this.lmNotificationSuccessMessage({
          description: this.$t('cover_updated_succeded')
        })
        await this.getInternalDocuments()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async checkAutomationRules (data = {}) {
      if (this.disableAutomations) return
      const response = await commonsApi.axiosGetWrapper('/automation/get-processes/', {
        id: this.processTypeMasterId
      })
      let msg

      for (const process of response.data) {
        if (process.do.event.value === 'document-suggested') {
          const { from, to } = process.when.details

          // Si el estado actual no coincide con la validación
          if (Number(data.statusFrom) !== from.id && from.id !== 'any') continue
          // Si el nuevo estado no coincide con la validación
          if (Number(data.statusTo) !== to.id && to.id !== 'any') continue
          const documents = this.processForm.documents

          const condition = documents.some(el => {
            if (!el.deleted_at && el.document._masterType === process.do.details._master) {
              // Si se especificó un estado en concreto del documento
              if (
                process.do.details.status.id !== 'any' &&
                process.do.details.status.id !== Number(el.document.lumbreStatus.id)
              ) {
                return false
              }
              return true
            }
            return false
          })

          if (!condition) {
            msg = `El trámite debe contener al menos un documento de tipo ${process.do.details.name}`

            if (process.do.details.status.id !== 'any') {
              msg += ` en estado ${process.do.details.status.name}`
            }
            this.automation.qs = `documentTypeId: ${process.do.details.id}`
            this.automation.required = process.do.details._master

            await this.handleAutomationFrontError({
              required: this.automation.required,
              message: msg
            })
          }
        }
      }
    },

    async changeStatus (event) {
      await commonsApi.axiosPostWrapper('/processes/newstatus', {
        id: this.processId,
        status: event
      })
      this.lmToastSuccessMessage(`Se actualizó el estado a ${event.name} correctamente.`, `Operación realizada con éxito.`)
      this.statusChange = false
      await Promise.all([
        this.getProcess(),
        this.getActionsAvailables(),
        this.getStatus()
      ])
    },

    async onChangeStatus (event = this.statusToBeChanged) {
      try {
        this.isProcessing = true
        await this.checkAutomationRules({
          statusFrom: this.processForm.lumbreStatus.id,
          statusTo: this.statusToBeChanged.id
        })
        await this.changeStatus(this.statusToBeChanged)
      } catch (error) {
        console.log(error)
        this.handleAutomationError(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onProcessStatusChange (event) {
      try {
        this.isProcessing = true
        this.processForm.lumbreStatus = event
        await Promise.all([
          this.getProcess(),
          this.getActionsAvailables()
        ])
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onProcessPassChange (event) {
      try {
        this.isProcessing = true
        this.processForm.lastMovement.destination = event
        await Promise.all([
          this.getProcess(),
          this.getActionsAvailables(),
          this.getDocuments(),
          this.getBlueprints(),
          this.getInternalDocuments()
        ])
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onAddLinkedProcesses () {
      try {
        this.isProcessing = true
        this.$refs.toolbar.updateToolbarMode(null)
        await Promise.all([
          this.getProcess(),
          this.getActionsAvailables(),
          this.getInternalDocuments()
        ])
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    onOpenToolbarProcessPasses () {
      this.$refs.toolbar.updateToolbarMode('processPasses')
    },

    onContentTemplateChange (event) {
      for (const key in this.processForm) {
        if (event.hasOwnProperty(key)) {
          this.processForm[key] = event[key]
        }
      }
      this.currentInitiatorType = event.currentInitiatorType
      this.currentInitiator = event.currentInitiator
      this.identifier.id = this.currentInitiator.personId
      this.identifier.type = this.currentInitiator.personIdType
    },

    async onRemoveProcessLink (item) {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper('/processes/removerelationship', {
          id: this.processId,
          relatedProcessId: item.id
        })
        this.lmToastSuccessMessage(`Se eliminó ${item.name} correctamente.`, 'Acción realizada con éxito.')
        await this.getProcess()
        if (!this.processForm.processRelationships.length) {
          this.$bvModal.hide('linked-processes-modal')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onRemoveInternalDocument (doc) {
      try {
        this.isProcessing = true
        this.$refs['confirmation-modal'].setMessageProps(`Está seguro que desea eliminar el documento ${doc.name}?`)
        await this.$refs['confirmation-modal'].lmShow()
        if (this.isOnEditMode && doc.id !== undefined) {
          await commonsApi.axiosPutWrapper('/processes/deleteinternaldocument', {
            documentId: doc.id,
            processId: this.processId
          })
        }
        this.processForm.internalDocuments = this.processForm.internalDocuments.filter(el => el.id !== doc.id)
        this.lmToastSuccessMessage(`Se eliminó ${doc.name || ' el documento'} correctamente.`, 'Acción realizada con éxito')
        this.documentsChange = this.processForm.internalDocuments.some(el => !el.hasOwnProperty('id'))
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    processPath (event) {
      return {
        name: 'process-editar',
        params: {
          processTypeId: event.typeId,
          id: event.id,
          showGoBackButton: true
        }
      }
    },

    async onShowCoverPage () {
      try {
        const response = await commonsApi.axiosGetWrapper('/processes/coverpage/' + this.processId)
        this.coverPagePreview = {
          src: response.data.src,
          name: response.data.originalName
        }
        this.$bvModal.show('cover-page-preview-modal')
      } catch (error) {
        console.log(error)
      }
    },

    onShowAdditionalInitiatorsModal () {
      this.$bvModal.show('people-all-additional-initiator-modal')
    },

    onShowInitiatorDetails () {
      if (this.currentInitiatorType.starterType === 'people') {
        this.$bvModal.show('people-initiator-modal')
      } else {
        this.$bvModal.show('initiator-modal')
      }
    },

    onShowAdditionalInitiatorDetails (index) {
      this.additionalInitiatorToShowOnModal = index
      if (this.currentInitiatorType.starterType === 'people') {
        this.$bvModal.show('people-additional-initiator-modal')
      } else {
        this.$bvModal.show('initiator-modal')
      }
    },

    onUpdatePeopleInitiator (event) {
      this.processForm.processStarter = {
        id: event._id,
        name: event.personName,
        starterTypeId: event.peopleTypeId,
        starterType: 'people'
      }
      this.currentInitiator = {
        personName: event.personName,
        personEmail: event.personEmail,
        ...event
      }
      this.identifier.id = this.currentInitiator.personId
      this.identifier.type = this.currentInitiator.personIdType
      this.$bvModal.hide('people-initiator-modal')
      this.step0completed = true

      // if (this.actionsAvailables.processCanBeEditedCoverPage) {
      if ((this.actionsAvailables.processCanBeEditedCoverPage && this.actionsAvailables.processCanBeEditedByMe) || (this.actionsAvailables.processCanBeEditedCoverPage && this.actionsAvailables.processCanBeEditedByMePermissions)) {
        this.lmModalInformationMessage({
          resultSubtitle: this.$t('cover_affected'),
          buttons: [
            {
              btnText: this.$t('cancel')
            },
            {
              btnText: this.$t('update_cover'),
              btnCallback: async () => {
                await this.onUpdateCover()
              }
            }
          ]
        })
      }
    },

    onCreatePeopleInitiator (event) {
      this.processForm.processStarter = {
        id: event._id,
        name: event.personName,
        starterTypeId: event.peopleTypeId,
        starterType: 'people'
      }
      this.currentInitiator = {
        personName: event.personName,
        personEmail: event.personEmail,
        ...event
      }
      this.identifier.id = this.currentInitiator.personId
      this.identifier.type = this.currentInitiator.personIdType
      this.$bvModal.hide('people-initiator-modal')
      this.step0completed = true
    },

    onSaveWithFeedback () {
      this.lmModalInformationMessage({
        resultSubtitle: this.$t('cover_affected'),
        buttons: [
          // Se comenta por: https://app.clickup.com/t/3hd97t4
          {
            btnText: this.$t('cancel'),
            btnCallback: async () => {
              this.showFormbuilderForEdit = false
              await this.getProcess()
            }
          },
          {
            btnText: this.$t('update_cover'),
            btnCallback: async () => {
              this.showFormbuilderForEdit = false
              await this.onSave()
              await this.onUpdateCover()
            }
          }
        ]
      })
    },

    async onSaveWithoutFeedback () {
      this.showFormbuilderForEdit = false
      await this.onSave()
    },

    async onUnsavedChanges () {
      this.lmModalWarningMessage({
        resultTitle: this.$t('changes_unsaved'),
        resultSubtitle: this.$t('changes_unsaved_subtitle'),
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('save'),
            btnCallback: async () => {
              await this.onSave()
              this.$refs.toolbar.updateToolbarMode('processPasses')
            }
          }
        ]
      })
    },

    async onSave () {
      try {
        this.isProcessing = true
        if (this.isOnEditMode) {
          const response = await commonsApi.axiosPutWrapper(`/processes/edit/${this.processId}`, this.requestParams)

          if (this.statusChange) {
            await this.onChangeStatus()
          }
          await Promise.all([
            this.getStatus(),
            this.getDocuments(),
            this.getBlueprints()
          ])

          let message = this.$t('save_process_succeded')

          if (response.data?.processName) {
            message = this.$t('process.confirmations.save_succeded_with_processname')
          }

          this.lmToastSuccessMessage(message)
        } else {
          await this.checkAutomationRules({
            statusFrom: 0,
            statusTo: 1
          })

          const response = await commonsApi.axiosPostWrapper('/processes/new', this.requestParams)

          this.lmModalSuccessWithButtons({
            modalClosable: false,
            modalKeyboard: false,
            buttons: [
              {
                btnText: this.$t('continue'),
                btnCallback: async () => {
                  this.$router.replace(`/tramites/${response.data.processTypeId}/editar/${response?.data?._id}`)
                }
              }
            ],
            message: this.$t('create_process_succeded', { processName: response?.data?.processName })
          })
        }
        this.documentsChange = false
        this.processChange = false
      } catch (error) {
        console.log(error)
        this.handleAutomationError(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onRequestStart () {
      try {
        this.isProcessing = true
        this.$bvModal.show('request-start-modal')
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async handleAutomationFrontError (error) {
      return new Promise((resolve, reject) => {
        this.automation.qs = `_masterType: ${error.required} AND deleted: false`
        this.automation.required = error.required
        this.automation.errorMsg = error.message
        this.lmModalWarningMessage({
          modalClosable: false,
          modalKeyboard: false,
          buttons: [
            {
              btnText: this.$t('continue'),
              btnType: 'default',
              btnGhost: false,
              btnCallback: async () => {
                this.automation.qs = null
                resolve()
              }
            },
            {
              btnText: this.$t('search_already_created'),
              btnCallback: async () => {
                this.$bvModal.show('documents-datatable-modal')
                reject(new Error('automation error'))
              }
            },
            {
              btnText: this.$t('create_a_new_one'),
              btnCallback: async () => {
                this.$router.push(`/documentos/${this.automation.required}/nuevo`)
                reject(new Error('automation error'))
              }
            }
          ],
          message: this.automation.errorMsg,
          resultTitle: this.$t('continue_confirmation')
        })
      })
    },

    handleAutomationError (error) {
      if (error.response?.data?.type === 'AUTOMATION_ERR') {
        this.automation.qs = `_masterType: ${error.response?.data?.data?.automation?.required} AND deleted: false`
        this.automation.required = error.response?.data?.data?.automation?.required
        this.automation.errorMsg = error.response?.data?.message
        this.lmModalDangerMessage({
          modalClosable: false,
          modalKeyboard: false,
          buttons: [
            {
              btnText: this.$t('cancel'),
              btnType: 'default',
              btnGhost: false,
              btnCallback: async () => {
                this.automation.qs = null
              }
            },
            {
              btnText: this.$t('search_already_created'),
              btnCallback: async () => {
                this.$bvModal.show('documents-datatable-modal')
              }
            },
            {
              btnText: this.$t('create_a_new_one'),
              btnCallback: async () => {
                this.$router.push(`/documentos/${this.automation.required}/nuevo`)
              }
            }
          ],
          message: this.automation.errorMsg
        })
      }
    },

    async onStart () {
      try {
        this.isProcessing = true
        let targetEndpoint = '/processes/'
        let action
        if (this.isOnEditMode) {
          if (this.actionsAvailables.processCanBeStartedByMe) {
            targetEndpoint += 'start'
            action = 'inició'
            await this.checkAutomationRules({
              statusFrom: this.processForm.lumbreStatus.id,
              statusTo: 3
            })
          } else if (this.actionsAvailables.processCanBeRequestStartedByMe) {
            targetEndpoint += 'requeststart'
            action = 'solicitó iniciar'
            this.$bvModal.hide('request-start-modal')
            await this.checkAutomationRules({
              statusFrom: 1,
              statusTo: 11
            })
          }
        } else {
          if (this.actionsAvailables.processCanBeStartedByMe) {
            targetEndpoint += 'createandstart'
            action = 'inició'
            await this.checkAutomationRules({
              statusFrom: this.processForm.lumbreStatus?.id,
              statusTo: 3
            })
          } else if (this.actionsAvailables.processCanBeRequestStartedByMe) {
            targetEndpoint += 'createandrequeststart'
            action = 'solicitó iniciar'
            this.$bvModal.hide('request-start-modal')
            await this.checkAutomationRules({
              statusFrom: 1,
              statusTo: 11
            })
          }
        }
        const response = await commonsApi.axiosPostWrapper(targetEndpoint, this.requestParams)

        this.lmModalSuccessWithButtons({
          modalClosable: false,
          modalKeyboard: false,
          buttons: [
            {
              btnText: this.$t('continue'),
              btnCallback: async () => {
                if (this.actionsAvailables.processCanBeStartedByMe || this.actionsAvailables.processCanBeRequestStartedByMe) {
                  if (this.isOnEditMode) {
                    await Promise.all([
                      this.getProcess(),
                      this.getActionsAvailables(),
                      this.getStatus(),
                      this.getDocuments(),
                      this.getBlueprints(),
                      this.getInternalDocuments()
                    ])
                    this.currentStep = 3
                    this.documentsChange = false
                  } else {
                    this.$router.push(`/tramites/${response.data.processTypeId}/editar/${response?.data?._id}`)
                  }
                }
              }
            }
          ],
          message: this.$t('process.confirmations.start_confirmation_with_processname', {
            processName: response?.data?.processName,
            actionName: action
          })
        })
      } catch (error) {
        console.log(error)
        this.handleAutomationError(error)
      } finally {
        this.isProcessing = false
      }
    },

    onTakeConfirmation () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.onTake()
            }
          }
        ],
        message: this.$t('process.confirmations.take_confirmation')
      })
    },

    async onTake () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPostWrapper('/processes/take', {
          id: this.processId
        })

        this.lmModalSuccessWithButtons({
          modalClosable: false,
          modalKeyboard: false,
          buttons: [
            {
              btnText: this.$t('continue'),
              btnCallback: async () => {
                await Promise.all([
                  this.getProcess(),
                  this.getActionsAvailables(),
                  this.getInternalDocuments()
                ])
              }
            }
          ],
          message: this.$t('take_process_succeded', { processName: this.processForm.processName })
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onReject (rejectComment) {
      try {
        this.isProcessing = true
        await this.checkAutomationRules({
          statusFrom: this.processForm.lumbreStatus.id,
          statusTo: 1
        })
        await commonsApi.axiosPostWrapper('/processes/reject', {
          id: this.processId,
          reason: typeof (rejectComment) === 'string' && rejectComment !== 'ok' ? rejectComment : null
        })
        this.lmToastSuccessMessage(`Se rechazó el trámite ${this.processForm.processName} correctamente.`, `Operación realizada con éxito.`)
        this.$router.push('/inbox')
      } catch (error) {
        this.handleAutomationError(error)
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onReOpen () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPostWrapper('/processes/reopen', {
          id: this.processId
        })
        this.lmToastSuccessMessage(`Se reabrió correctamente el trámite ${this.processForm.processName}.`, `Operación realizada con éxito.`)
        await Promise.all([
          this.getProcess(),
          this.getActionsAvailables(),
          this.getStatus()
        ])
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    onPrevStep () {
      this.currentStep--
    },

    onNextStep () {
      this.currentStep++
    },

    async onOpenDocumentInPdf (id) {
      this.$bvModal.show('document-preview-modal')
      const response = await commonsApi.axiosGetWrapper('/documents/' + id)
      this.documentInPdf = response.data.documentInPdf
    },

    onOpenInternalDocumentInPdf (doc) {
      this.$bvModal.show('document-preview-modal')
      this.documentInPdf = doc
    },

    fileIsValidForViewer (filename) {
      const extensionesValidas = ['pdf', 'png', 'jpeg', 'jpg', 'gif']
      return extensionesValidas.some(palabra => filename.toLowerCase().endsWith(palabra))
    },

    async onBackwardForward (doc) {
      const index = await this.onOpenDocumentViewerModal(doc, this.fileViewerMode)
      this.$refs.fileviewer.lazyLoadUpdate(this.currentFileList[index])
    },

    async onOpenDocumentViewerModal (doc, mode) {
      let files = this.fileList.filter(el => el.type === mode)
      this.isDocumentsLoading = true
      if (mode === 'budds') {
        files.sort((a, b) => a.order - b.order)
      } else if (mode === 'internals') {
        files.reverse()
      }

      this.currentFileList = files
      const id = doc._id || doc.id || doc.uuid
      const index = this.currentFileList.findIndex(el => el.id === id)
      if (!this.currentFileList[index]?.path) {
        const response = await commonsApi.axiosGetWrapper('/documents/pdf/' + id)
        const fileListIndex = this.fileList.findIndex(el => el.id === id)
        this.fileList[fileListIndex] = {
          ...this.fileList[fileListIndex],
          ...response.data,
          path: response.data.src
        }

        this.currentFileList[index] = this.fileList[fileListIndex]
      }
      this.fileViewerIniialPosition = index || 0
      this.showDocumentsViewer = true
      this.fileViewerMode = mode
      this.isDocumentsLoading = false
      return index
    },

    async onConfirmAppDocuments () {
      try {
        this.isTableLoading = true
        const selected = this.$refs['datatable-app-documents'].dataValue
        if (selected) {
          const currentDocumentsIds = this.processForm.documents.map(el => el.id)
          const documentsIds = selected.filter(el => !currentDocumentsIds.includes(el.id)).map(el => el.id)

          if (!documentsIds.length) return

          const response = await commonsApi.axiosPostWrapper('/documents/es-search', {
            ids: documentsIds,
            fields: ['id', 'documentTypeId', 'documentName', 'documentNumber', 'documentTypeAlias', '_masterType']
          })

          const items = response.data.items.map(el => {
            el._id = el.id
            return {
              id: el.id,
              order: 'N/A',
              canBeDeleted: true,
              canBeCorrected: false,
              document: el,
              metadata: {}
            }
          })
          this.processForm.documents = [].concat(this.processForm.documents, items)
          this.documentsChange = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isTableLoading = false
      }
    },

    async onConfirmAppBlueprints () {
      try {
        this.isTableLoading = true
        const selected = this.$refs['datatable-app-blueprints'].dataValue
        if (selected) {
          const currentBlueprintsIds = this.processForm.blueprints.filter(el => !el.hasBeenDeleted).map(el => el.id)
          const blueprintsIds = selected.filter(el => !currentBlueprintsIds.includes(el.id)).map(el => el.id)

          if (!blueprintsIds.length) return

          const response = await commonsApi.axiosPostWrapper('/blueprints/es-search', {
            ids: blueprintsIds,
            fields: ['id', 'nomenclaturaCode', 'nomenclaturaCuenta', 'name', 'typeId', 'typeAlias', '_masterType', 'blueprintFiles']
          })

          const items = response.data.items.map(el => {
            el._id = el.id
            let path
            let name
            if (el.blueprintFiles?.length) {
              path = el.blueprintFiles[0].path
              name = el.blueprintFiles[0].name
            }
            return {
              id: el.id,
              order: 'N/A',
              canBeDeleted: true,
              canBeCorrected: false,
              blueprint: el,
              path: path,
              name: name,
              metadata: {}
            }
          })
          this.processForm.blueprints = [].concat(this.processForm.blueprints, items)
          this.documentsChange = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isTableLoading = false
      }
    },

    onAddInternalDocument (event) {
      for (const item of event) {
        if (!this.internalDocumentsToAppend.some(el => el.uuid === item.uuid)) {
          this.internalDocumentsToAppend.push(item)
        }

        if (!this.processForm.internalDocuments.some(el => el.uuid === item.uuid)) {
          this.processForm.internalDocuments.push(item)
        }
      }
      this.documentsChange = true
    },

    onOpenDocument (item) {
      this.$router.push(`/documentos/${item.documentTypeId}/editar/${item._id}`)
    },

    onOpenBlueprint (item) {
      this.$router.push(`/planos/${item.typeId}/editar/${item._id}`)
    },

    async onRemoveBlueprint (blueprint) {
      try {
        this.isProcessing = true
        this.$refs['confirmation-modal'].setMessageProps(`Está seguro que desea eliminar el plano "${blueprint.name}"?`)
        await this.$refs['confirmation-modal'].lmShow()
        if (this.isOnEditMode && blueprint._id !== undefined) {
          await commonsApi.axiosPutWrapper('/processes/deleteblueprint', {
            processId: this.processId,
            blueprintId: blueprint._id
          })
          this.getBlueprints()
        }
        this.processForm.blueprints = this.processForm.blueprints.filter(el => el._id !== blueprint._id)
        this.lmToastSuccessMessage(`Se eliminó ${blueprint.name || ' el documento'} correctamente.`, 'Acción realizada con éxito')
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },

    async onShowReplacementModal (item) {
      this.documentToBeReplaced = item
      this.showReplacementModal = true
    },

    onRemoveDocument (item) {
      const id = item._id || item.id
      this.processForm.documents = this.processForm.documents.filter(el => el.id !== id)
      this.documentsChange = this.processForm.documents.some(el => el.order === 'N/A')
    },

    async onReplaceDocumentWithDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPostWrapper('/processes/correctdocument', {
          processId: this.processId,
          documentId: this.documentToBeReplaced._id
        })
        await this.getDocuments()
      } catch (error) {
        console.log(error)
      } finally {
        this.showReplacementModal = false
        this.isProcessing = false
      }
    },

    onReplaceDocument () {
      this.showReplacementModal = false
      this.showReplacementDocumentModal = true
    },

    async onConfirmReplacementDocument () {
      try {
        this.isLoading = true
        this.showReplacementDocumentModal = false
        const replacementDocumentId = this.$refs['datatable-app-replacement-documents'].dataValue.at(0)?.id
        await commonsApi.axiosPostWrapper('/processes/correctdocument', {
          processId: this.processId,
          documentId: this.documentToBeReplaced._id,
          newDocumentId: replacementDocumentId
        })
        await this.getDocuments()
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },

    replacementFeedbackDateTooltip (item) {
      return `Subsanado el ${moment(item.metadata.replacement_date).format('DD [de] MMM, YYYY - HH:mm')}`
    },

    removedFeedbackDateTooltip (item) {
      return `Eliminado el ${moment(item.metadata.replacement_date).format('DD [de] MMM, YYYY - HH:mm')}`
    },

    blueprintRemovedFeedbackDateTooltip (item) {
      return `Eliminado el ${moment(item.deleted_at).format('DD [de] MMM, YYYY - HH:mm')}`
    },

    clearInitiator (type) {
      this.currentInitiator = null
      this.processForm.processAdditionalInitiators = []
      // si tiene un solo type queda seleccionado, por lo tanto no se limpia
      if (!type) this.identifier.type = null
      this.identifier.id = null
    },

    onSelectInitiator (item) {
      if (item._id !== this.currentInitiatorType?._id) {
        this.currentInitiatorType = item
        if (this.currentInitiatorType.idType.length === 1) {
          this.identifier.type = this.currentInitiatorType.idType[0]
        }
        this.clearInitiator(this.identifier.type)
      }
    },

    async onSearchInitiator () {
      const response = await commonsApi.axiosGetWrapper(`/people/search/${this.currentInitiatorType._id}/${this.identifier.type.id}/${this.identifier.id}`)
      if (response.data.length) {
        this.currentInitiator = response.data.shift()
        this.step0completed = true
      } else {
        this.lmModalInformationMessage({
          modalClosable: false,
          modalKeyboard: false,
          resultSubtitle: this.$t('person_doesnt_exists'),
          buttons: [
            {
              btnText: this.$t('cancel'),
              btnType: 'danger',
              btnGhost: true
            },
            {
              btnText: this.$t('accept'),
              btnCallback: () => {
                this.currentInitiator = null
                this.processForm.processStarter = {}
                this.$bvModal.show('people-initiator-modal')
              }
            }
          ],
          message: this.$t('person_doesnt_exists_detail')
        })
      }
    },

    async onSearchAdditionalInitiator (index) {
      const response = await commonsApi.axiosGetWrapper(`/people/search/${this.currentInitiatorType._id}/${this.processForm.processAdditionalInitiators[index].identifier.type.id}/${this.processForm.processAdditionalInitiators[index].identifier.id}`)
      if (response.data.length) {
        this.processChange = true
        this.processForm.processAdditionalInitiators[index].additionalInitiator = response.data.shift()
        this.processForm.processAdditionalInitiators[index].isLoading = false
      } else {
        this.lmModalInformationMessage({
          modalClosable: false,
          modalKeyboard: false,
          resultSubtitle: this.$t('person_doesnt_exists'),
          buttons: [
            {
              btnText: this.$t('cancel'),
              btnType: 'danger',
              btnGhost: true
            },
            {
              btnText: this.$t('accept'),
              btnCallback: () => {
                this.processForm.processAdditionalInitiators[index].additionalInitiator = {}
                this.additionalInitiatorToShowOnModal = index
                this.$bvModal.show('people-additional-initiator-modal')
              }
            }
          ],
          message: this.$t('person_doesnt_exists_detail')
        })
      }
    },

    updateProcessForm (event) {
      for (const key in event) {
        if (this.processFormCopy.hasOwnProperty(key)) {
          if (this.processFormCopy[key] !== event[key]) {
            this.processChange = true
            break
          } else {
            this.processChange = false
          }
        }
      }
      this.processForm = Object.assign({}, this.processForm, event)
    },

    async getInitiators () {
      const response = await commonsApi.axiosGetWrapper('/peopletypes/allstarterstypes/' + this.processTypeId)
      this.initiators = response.data
    },

    async getProcessType () {
      const response = await commonsApi.axiosGetWrapper('/processtypes/' + this.processTypeId)
      this.processTypeForm = response.data
      return this.getRequestStartOptions()
    },

    async getProcess () {
      if (!this.isOnEditMode) return
      const response = await commonsApi.axiosGetWrapper(`/processes/${this.processId}`)
      // Guardo los documentos budd y documentos internos ya que no vienen con el GET a processes
      const documents = _.cloneDeep(this.processForm.documents)
      const internalDocuments = _.cloneDeep(this.processForm.internalDocuments)
      const blueprints = _.cloneDeep(this.processForm.blueprints)
      this.processForm = {
        ...response.data,
        // Los blueprints se obtienen en getBlueprints() y para lograr que el
        // watch de processForm.blueprints siga reactivo me aseguro que sea un
        // array
        blueprints: []
      }
      this.processForm.documents = documents
      this.processForm.internalDocuments = internalDocuments
      this.processForm.blueprints = blueprints
      this.markerLatLng = this.processForm?.processAddressLatLong || []

      this.currentInitiatorType = this.initiators.find(el => {
        return el._id === response.data.processStarter.starterTypeId
      })
      await this.getInitiator(response.data.processStarter.id)
      await this.getAdditionalInitiators()
    },

    async getInitiator (id) {
      if (this.currentInitiatorType.starterType === 'people') {
        const response = await commonsApi.axiosGetWrapper('/people/' + id)
        this.currentInitiator = response.data
        this.identifier.id = response.data.personId
        this.identifier.type = response.data.personIdType
      } else {
        this.currentInitiator = {
          name: this.processForm.processStarter.name,
          fields: this.processForm.initiatorFields
        }
      }
    },

    async getAdditionalInitiators () {
      if (this.currentInitiatorType.starterType === 'people') {
        for (const initiator of this.processForm.processAdditionalInitiators) {
          const response = await commonsApi.axiosGetWrapper('/people/' + initiator.id)
          initiator.additionalInitiator = response.data
          initiator.identifier = {
            id: response.data.personId,
            type: response.data.personIdType
          }
        }
      }
    },

    async getActionsAvailables () {
      let targetEndpoint
      if (!this.isOnEditMode) {
        targetEndpoint = '/processes/actionsavailableoncreate/' + this.processTypeId
      } else {
        targetEndpoint = '/processes/actionsavailable/' + this.processId
      }
      const response = await commonsApi.axiosGetWrapper(targetEndpoint)
      this.actionsAvailables = response.data
    },

    async getRequestStartOptions () {
      try {
        if (this.processTypeForm.instanceActions) {
          const { area, subarea } = this.processTypeForm.instanceActions
          if (!area.length && !subarea.length) {
            const areasPromise = commonsApi.axiosGetWrapper('/customer/areas')
            const subareasPromise = commonsApi.axiosGetWrapper('/customer/subareas')
            const [ areas, subareas ] = await Promise.all([areasPromise, subareasPromise])
            this.requestStartOptions.areas = areas.data.items
            this.requestStartOptions.subareas = subareas.data.items
          } else {
            const starterUsers = await commonsApi.axiosGetWrapper('/processtypes/' + this.processTypeId + '/starters')
            this.requestStartOptions.users = starterUsers.data.items
            this.requestStartOptions.areas = area.filter(el => el?.action === 'S')
            this.requestStartTypeOptions = []
            if (this.requestStartOptions.areas?.length) {
              this.requestStartTypeOptions.push({
                id: 'area',
                name: 'Areas'
              })
            }
            this.requestStartOptions.subareas = subarea.filter(el => el?.action === 'S')
            if (this.requestStartOptions.subareas?.length) {
              this.requestStartTypeOptions.push({
                id: 'subarea',
                name: 'Subareas'
              })
            }
            if (this.requestStartOptions.users?.length) {
              this.requestStartTypeOptions.push({
                id: 'user',
                name: 'Usuarios'
              })
            }

            this.requestersCategoriesOptions = []
            if (this.requestStartOptions?.users?.length > 0) {
              this.requestersCategoriesOptions.push({ text: 'Usuario', value: 'user' })
            }
            if (this.requestStartOptions?.areas?.length > 0) {
              this.requestersCategoriesOptions.push({ text: 'Área', value: 'area' })
            }
            if (this.requestStartOptions?.subareas?.length > 0) {
              this.requestersCategoriesOptions.push({ text: 'Subárea', value: 'subarea' })
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    async getStatus () {
      const response = await commonsApi.axiosGetWrapper('/processes/statusavailable/' + this.processId)
      this.statusList = response.data.items || []
    },

    async getDocuments () {
      const response = await commonsApi.axiosGetWrapper('/processes/documents/' + this.processId)
      this.processForm.documents = response.data.items.map(el => ({ id: el._id, ...el })) || []
    },

    async getBlueprints () {
      const response = await commonsApi.axiosGetWrapper('/processes/blueprints/' + this.processId)
      this.processForm.blueprints = response.data.items.map(el => ({ id: el._id, ...el })) || []
    },

    async getInternalDocuments () {
      const response = await commonsApi.axiosGetWrapper('/processes/internaldocuments/' + this.processId)
      this.processForm.internalDocuments = response.data.items.map(el => ({ id: el._id, ...el })) || []
    },

    validateProcessTypeIsPublished () {
      if (!this.isOnEditMode && !this.processTypeForm.published) {
        this.lmModalDangerMessage({
          btnText: this.$t('go_back'),
          btnLink: 'goback',
          modalClosable: false,
          modalKeyboard: false,
          resultSubtitle: this.$t('talk_to_admin'),
          message: this.$t('process_type_not_published')
        })
      }
    },

    removeDuplicates () {
      this.fileList = this.fileList.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.id === value.id
        ))
      )
    },

    placeChanged (place) {
      const latLong = [
        place.geometry.location.lat(),
        place.geometry.location.lng()
      ]
      this.markerLatLng = latLong
      this.processForm.processAddressLatLong = latLong
      this.processForm.processAddress = place.formatted_address
    },

    inputLmGooglePlacesAutocomplete (value) {
      if (!value) {
        this.markerLatLng = []
        this.processForm.processAddressLatLong = []
        this.processForm.processAddress = ''
      }
    },

    onAddAdditionalInitiator () {
      let identifierType = null
      if (this.currentInitiatorType.idType.length) {
        identifierType = this.currentInitiatorType.idType[0]
      }
      this.processForm.processAdditionalInitiators.push({
        identifier: {
          type: identifierType,
          id: null
        },
        additionalInitiator: {
          personName: null,
          personEmail: null
        },
        isLoading: true
      })
    },

    onDeleteAdditionalInitiator (index) {
      this.processChange = true
      this.processForm.processAdditionalInitiators.splice(index, 1)
    },

    onInitiatorChange () {
      this.currentInitiator = null
    },

    onAdditionalInitiatorChange (index) {
      this.processChange = true
      this.processForm.processAdditionalInitiators[index].additionalInitiator = {
        personName: null,
        personEmail: null
      }
      this.processForm.processAdditionalInitiators[index].isLoading = true
    },

    async onCreateAdditionalPeopleInitiator (event) {
      await this.$nextTick()
      this.$set(this.processForm.processAdditionalInitiators, this.additionalInitiatorToShowOnModal,
        {
          _id: event._id,
          name: event.personName,
          starterTypeId: event.peopleTypeId,
          starterType: 'people',
          identifier: {
            type: this.currentInitiator.personIdType,
            id: event.personId
          },
          additionalInitiator: {
            _id: event._id,
            personName: event.personName,
            personEmail: event.personEmail
          },
          isLoading: false
        })
      this.processForm.processAdditionalInitiators[this.additionalInitiatorToShowOnModal].isLoading = false
      this.$bvModal.hide('people-additional-initiator-modal')
    },

    async onUpdateAdditionalPeopleInitiator (event) {
      await this.$nextTick()
      this.$set(this.processForm.processAdditionalInitiators, this.additionalInitiatorToShowOnModal,
        {
          _id: event._id,
          name: event.personName,
          starterTypeId: event.peopleTypeId,
          starterType: 'people',
          identifier: {
            type: this.currentInitiator.personIdType,
            id: event.personId
          },
          additionalInitiator: {
            _id: event._id,
            personName: event.personName,
            personEmail: event.personEmail
          },
          isLoading: false
        })

      this.$bvModal.hide('people-additional-initiator-modal')

      // if (this.actionsAvailables.processCanBeEditedCoverPage) {
      if ((this.actionsAvailables.processCanBeEditedCoverPage && this.actionsAvailables.processCanBeEditedByMe) || (this.actionsAvailables.processCanBeEditedCoverPage && this.actionsAvailables.processCanBeEditedByMePermissions)) {
        this.lmModalInformationMessage({
          resultSubtitle: this.$t('cover_affected'),
          buttons: [
            {
              btnText: this.$t('cancel')
            },
            {
              btnText: this.$t('update_cover'),
              btnCallback: async () => {
                await this.onUpdateCover()
              }
            }
          ]
        })
      }
    },

    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPostWrapper('/processes/delete_process', {
          id: this.processId
        })
        this.lmToastSuccessMessage(`Se eliminó correctamente el trámite ${this.processForm.processName}.`, `Operación realizada con éxito.`)
        this.$router.push('/')
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    }
  },

  watch: {
    async currentStep (val, oldVal) {
      try {
        this.stepsMovements.push(oldVal)
        if (oldVal === 0) {
          this.step0completed = this.step0completed || !!(this.currentInitiatorType && this.currentInitiator)
        }
        if (oldVal === 1) {
          if (!this.step0completed) return
          await this.$refs['process-formbuilder'].validate()
          await this.validateForm(this.$v)
          this.step1completed = true
        }
        // if (oldVal === 2) {
        //   this.step2completed = !!this.processForm.documents.length
        // }
      } catch (error) {
        if (oldVal === 1) {
          this.step1completed = false
        }
      }
    },
    processForm: {
      deep: true,
      handler (val) {
        if (this.$refs['process-formbuilder']) {
          if (this.$refs['process-formbuilder'].$v.$invalid === false && this.$v.$invalid === false) {
            this.step1completed = true
          } else {
            this.step1completed = false
          }
        }
      }
    },
    'processForm.documents': {
      deep: true,
      immediate: true,
      async handler (val) {
        try {
          this.isDocumentsLoading = true
          for (const doc of val) {
            if (!this.fileList.some(el => el.id === doc.id)) {
              this.fileList.push({
                id: doc.id,
                order: doc.order,
                type: 'budds'
              })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.isDocumentsLoading = false
          this.removeDuplicates()
        }
      }
    },
    'processForm.internalDocuments': {
      deep: true,
      immediate: true,
      handler (val) {
        try {
          this.isDocumentsLoading = true
          for (const doc of val) {
            if (!this.fileList.some(el => el.id === doc.id)) {
              this.fileList.push({
                id: doc.id || doc.uuid,
                ...doc,
                path: doc.src || process.env.VUE_APP_API_URL_STATIC_ASSETS + doc.path,
                type: 'internals'
              })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.isDocumentsLoading = false
          this.removeDuplicates()
        }
      }
    },
    'processForm.blueprints': {
      deep: true,
      immediate: true,
      async handler (val) {
        try {
          this.isDocumentsLoading = true
          for (const doc of val) {
            if (!this.fileList.some(el => el.id === doc.id)) {
              this.fileList.push({
                id: doc.id,
                ...doc,
                order: doc.order,
                type: 'blueprints'
              })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.isDocumentsLoading = false
          this.removeDuplicates()
        }
      }
    },
    requesterCategory: {
      deep: true,
      immediate: true,
      handler (val) {
        this.requester = null
      }
    }
  },

  async mounted () {
    try {
      this.isLoading = true
      await this.getInitiators()
      const promises = [
        this.getProcessType(),
        this.getProcess(),
        this.getActionsAvailables()
      ]

      if (this.isOnEditMode) {
        this.stepsMovements = [0, 1, 2]
        this.step0completed = true
        this.step1completed = true
        this.step2completed = true
        this.currentStep = 3
        promises.push(
          this.getStatus(),
          this.getDocuments(),
          this.getBlueprints(),
          this.getInternalDocuments()
        )
      }
      await Promise.all(promises)
      this.validateProcessTypeIsPublished()

      if (this.dataToPersist) {
        const backupData = _.cloneDeep(this.dataToPersist)
        // Del vuex store recuperamos todas las propiedades del trámite, pero
        // los documents budd los tomamos del valor actualizado que retornó el
        // backend. Porque puede ser que un usuario haya eliminado un documento
        // budd y previo a este fix ese cambio solo se veía reflejado cuando
        // se recargaba la pagina.
        // https://app.clickup.com/t/86ay4ccwn
        this.processForm = {
          ...backupData.processForm,
          documents: this.processForm.documents,
          blueprints: this.processForm.blueprints
        }
        this.currentInitiatorType = backupData.currentInitiatorType
        this.currentInitiator = backupData.currentInitiator
        this.identifier = backupData.identifier
        this.step0completed = backupData.step0completed
        this.step1completed = backupData.step1completed
        this.step2completed = backupData.step2completed
        this.currentStep = backupData.currentStep
        this.stepsMovements = backupData.stepsMovements
      }
      if (
        this.lastDocumentCreated &&
        !this.processForm.documents.some(el => el.id === this.lastDocumentCreated.id)
      ) {
        const response = await commonsApi.axiosPostWrapper('/documents/es-search', {
          ids: [this.lastDocumentCreated.id],
          fields: ['id', 'documentTypeId', 'documentName', 'documentNumber', 'documentTypeAlias']
        })
        const documentMetadata = response.data.items.at(0)
        const document = {
          document: documentMetadata,
          order: 'N/A',
          canBeDeleted: true,
          canBeCorrected: false,
          id: documentMetadata.id,
          metadata: {}
        }
        this.processForm.documents.push(document)
        this.documentsChange = true
      }

      this.processFormCopy = _.cloneDeep(this.processForm)
      this.$watch('processForm.processName', (val) => {
        this.processChange = Boolean(val)
      })
      this.$watch('processForm.processAddress', (val) => {
        this.processChange = Boolean(val)
      })
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },

  beforeRouteLeave (to, from, next) {
    if (
      (to?.name === 'documentos-nuevo' || to?.name === 'documentos-editar') &&
      !('viewer' in from.query)
    ) {
      this.setDataToPersist({
        processForm: this.processForm,
        currentInitiatorType: this.currentInitiatorType,
        currentInitiator: this.currentInitiator,
        identifier: this.identifier,
        step0completed: this.step0completed,
        step1completed: this.step1completed,
        step2completed: this.step2completed,
        currentStep: this.currentStep,
        stepsMovements: this.stepsMovements
      })
      this.setProcessPath(from.path)
    } else {
      this.clearProcessesStore()
      if (
        to.name !== 'process-editar' &&
        (this.showSaveAsDraftButton || this.showSaveButton || this.showSaveNewStatus)
      ) {
        this.lmModalWarningMessage({
          resultTitle: this.$t('changes_unsaved'),
          resultSubtitle: this.$t('changes_unsaved_subtitle'),
          buttons: [
            {
              btnText: this.$t('continue'),
              btnCallback: () => {
                this.documentsChange = false
                this.processChange = false
                this.statusChange = false
                this.processForm.documents = this.processForm.documents.filter(el => el.order !== 'N/A')
                this.$router.push(to.path)
              }
            },
            {
              btnText: this.$t('save'),
              btnCallback: async () => {
                await this.onSave()
                this.$router.push(to.path)
              }
            }
          ]
        })
        return false
      }
    }
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from?.name !== 'documentos-nuevo' && from?.name !== 'documentos-editar') {
        vm.clearProcessesStore()
      }
    })
  }
})
</script>

<style scoped>
.page-header {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 1rem 2rem;
  z-index: 4;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 95px;
}

#lm-leaflet-map {
  z-index: 0;
}

@media all and (max-width: 768px) {
  .page-header {
    padding: .4rem .8rem;
    height: auto;
  }
  .page-header h2 {
    font-size: 1.2rem;
    margin-bottom: 5px !important;
  }
}

.process-header > .process-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.page-content {
  width: calc(100% + 1rem);
  min-height: calc(100vh - 70px - 60px - 95px);
  margin-left: auto;
  /* display: flex; */

  display: grid;
  grid-template-columns: calc(100% - 100px) 100px;
}

.initiators-list {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, 20%);
}

.initiator-formbuilder {
  padding: 0;
}

.initiators-list > article {
  transition: all .2s ease-in-out;
}
.initiators-list > article:hover, .initiators-list > article.selected {
  transform: scale(1.020);
  filter: drop-shadow(0px 3px 5px #DCDCDC);
}

.initiator-searcher-form {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(100px, 25%));
  align-items: flex-end;
}
.initiator-searcher-form #lm-button-root-wrapper {
  padding-bottom: 2px;
}

.corrected {
  background-color: gray;
}

.status-squad-icon {
  width: 10px;
  height: 10px;
  display: inline-block;
  vertical-align: inherit;
  margin: 0 6px 0 0;
  background-color: #6FB200;
}
.status-button {
  background-color: #6FB200;
  color: white;
}
.status-button:hover {
  background-color: #6FB200;
  color: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  transform: scale(1.05);
  transition: ease-in-out .25s transform;
  border-color: rgba(149, 157, 165, 0.2);
}
.status-button:focus {
  border-color: rgba(149, 157, 165, 0.2);
}
.status-squad-icon.color-1, .status-button.color-1, .status-button:hover.color-1 {
  background-color: #007bff;
}
.status-squad-icon.color-5, .status-button.color-5, .status-button:hover.color-5 {
  background-color: yellow;
  color: black;
}
.status-squad-icon.color-6, .status-button.color-6, .status-button:hover.color-6 {
  background-color: cadetblue;
}
.status-squad-icon.color-7, .status-button.color-7, .status-button:hover.color-7 {
  background-color: green;
}
.status-squad-icon.color-8, .status-button.color-8, .status-button:hover.color-8 {
  background-color: #ABABD4;
}
.status-squad-icon.color-9, .status-button.color-9, .status-button:hover.color-9 {
  background-color: #5F1F7B;
}
.status-squad-icon.color-10, .status-button.color-10, .status-button:hover.color-10 {
  background-color: red;
}
.status-squad-icon.color-11, .status-button.color-11, .status-button:hover.color-11 {
  background-color: #97077D;
  color: black;
}
.status-squad-icon.color-12, .status-button.color-12, .status-button:hover.color-12 {
  background-color: teal;
}
.status-squad-icon.color-13, .status-button.color-13, .status-button:hover.color-13 {
  background-color: tomato;
}
.status-squad-icon.color-14, .status-button.color-14, .status-button:hover.color-14 {
  background-color: #132C7A;
}
.status-squad-icon.color-15, .status-button.color-15, .status-button:hover.color-15 {
  background-color: #00872A;
}
.status-squad-icon.color-16, .status-button.color-16, .status-button:hover.color-16 {
  background-color: #F63E2C;
}
.status-squad-icon.color-9999, .status-button.color-9999, .status-button:hover.color-9999 {
  background-color: orange;
}
</style>
